!(function (e, t) {
  return 'object' === typeof exports && 'object' === typeof module
    ? (module.exports = t(
        require('cuid'),
        require('axios'),
        require('yjs'),
        require('reconnecting-websocket')
      ))
    : 'function' === typeof define && define.amd
    ? define(['cuid', 'axios', 'yjs', 'reconnecting-websocket'], t)
    : 'object' === typeof exports
    ? (exports.WebCollabClient = t(
        require('cuid'),
        require('axios'),
        require('yjs'),
        require('reconnecting-websocket')
      ))
    : (e.WebCollabClient = t(
        e.cuid,
        e.axios,
        e.yjs,
        e['reconnecting-websocket']
      ))
})(self, (e, t, n, o) =>
  (() => {
    'use strict'
    var r = {
        9332: function (e, t, n) {
          var o =
              (this && this.__createBinding) ||
              (Object.create
                ? function (e, t, n, o) {
                    void 0 === o && (o = n)
                    var r = Object.getOwnPropertyDescriptor(t, n)
                    ;(r &&
                      !('get' in r
                        ? !t.__esModule
                        : r.writable || r.configurable)) ||
                      (r = {
                        enumerable: !0,
                        get: function () {
                          return t[n]
                        },
                      }),
                      Object.defineProperty(e, o, r)
                  }
                : function (e, t, n, o) {
                    void 0 === o && (o = n), (e[o] = t[n])
                  }),
            r =
              (this && this.__setModuleDefault) ||
              (Object.create
                ? function (e, t) {
                    Object.defineProperty(e, 'default', {
                      enumerable: !0,
                      value: t,
                    })
                  }
                : function (e, t) {
                    e.default = t
                  }),
            i =
              (this && this.__importStar) ||
              function (e) {
                if (e && e.__esModule) return e
                var t = {}
                if (null != e)
                  for (var n in e)
                    'default' !== n &&
                      Object.prototype.hasOwnProperty.call(e, n) &&
                      o(t, e, n)
                return r(t, e), t
              },
            s =
              (this && this.__awaiter) ||
              function (e, t, n, o) {
                return new (n || (n = Promise))(function (r, i) {
                  function s(e) {
                    try {
                      c(o.next(e))
                    } catch (t) {
                      i(t)
                    }
                  }
                  function a(e) {
                    try {
                      c(o.throw(e))
                    } catch (t) {
                      i(t)
                    }
                  }
                  function c(e) {
                    var t
                    e.done
                      ? r(e.value)
                      : ((t = e.value),
                        t instanceof n
                          ? t
                          : new n(function (e) {
                              e(t)
                            })).then(s, a)
                  }
                  c((o = o.apply(e, t || [])).next())
                })
              }
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.Collaboration = void 0)
          const a = n(8037),
            c = n(6526),
            d = i(n(6989)),
            l = i(n(5741)),
            u = n(9170),
            h = n(5608),
            f = n(4255),
            p = n(9648),
            v = n(1096),
            g = n(3933),
            y = n(5285),
            m = n(8907),
            S = n(9594)
          t.Collaboration = class {
            constructor(e, t) {
              ;(this.needToClosePDFDoc = !1),
                (this.openPDF = (e) =>
                  s(this, void 0, void 0, function* () {
                    this.needToClosePDFDoc = !0
                    const t = this.context.pdfViewer,
                      n = e
                        ? Object.assign(Object.assign({}, e), {
                            fileName: this.docName,
                          })
                        : { fileName: this.docName }
                    if (this.openFailedPDFDoc)
                      yield t.reopenPDFDoc(this.openFailedPDFDoc, n),
                        (this.openFailedPDFDoc = null)
                    else
                      try {
                        yield t.openPDFByHttpRangeRequest(
                          { range: { url: this.fileUrl } },
                          n
                        )
                      } catch (o) {
                        throw ((this.openFailedPDFDoc = o.pdfDoc), o)
                      }
                  })),
                (this.removeAllOriginalAnnotations = (e) =>
                  s(this, void 0, void 0, function* () {
                    const t = ['screen', 'link', 'sound']
                    S.LOGGER.debug(
                      'open PDF file success, starting to remove all original annots'
                    )
                    const n = yield e.getPageCount()
                    for (let o = 0; o < n; o++) {
                      const n = yield e.getPageByIndex(o),
                        r = yield n.getAnnots()
                      for (let e of r) {
                        const o = e.getObjectNumber(),
                          r = e.getType()
                        ;-1 === t.indexOf(r) &&
                          (yield n.removeAnnotByObjectNumber(o))
                      }
                    }
                    return (
                      S.LOGGER.debug(
                        'all original annots removed from PDF file'
                      ),
                      !0
                    )
                  })),
                (this.id = e.id),
                (this.fileUrl = e.fileUrl),
                (this.isDocPublic = e.isDocPublic),
                (this.docName = e.docName),
                (this.userAccessType = e.access),
                (this.openFailedPDFDoc = null),
                (this.authorId = e.authorId),
                (this.docPermission = e.docPermission || -1),
                (this.collabStatus = a.CollabStatus.CREATED),
                (this.createdAt = e.createdAt),
                (this.context = t),
                (t.permission = new u.Permission(
                  this.docPermission,
                  this.userAccessType
                ))
            }
            canJoin() {
              return s(this, void 0, void 0, function* () {
                return !!this.context.token && !!this.isDocPublic
              })
            }
            isJoined() {
              return (
                this.context.currentUser.id === this.authorId ||
                this.userAccessType === u.USER_ACCESS_TYPE.OWNER ||
                this.userAccessType === u.USER_ACCESS_TYPE.MEMBER
              )
            }
            join() {
              return s(this, void 0, void 0, function* () {
                const e = yield this.canJoin()
                if (this.isJoined()) return !0
                if (!e) return !1
                const t = this.context.currentUser,
                  n = this.context.sessionId
                return (
                  !!t &&
                  (yield d.join(this.id, n),
                  (this.userAccessType = 'member'),
                  !0)
                )
              })
            }
            assertPDFDocPermission(e) {
              if (!(32 & e.getPermissions()))
                throw new Error('Permission error')
            }
            begin(e) {
              return s(this, void 0, void 0, function* () {
                const t = this.context.pdfViewer
                if (
                  (this.context.wsInstance &&
                    this.context.currentDocId !== this.id &&
                    (yield (0, c.stopCollaboration)(this.context.currentDocId)),
                  this.collabStatus !== a.CollabStatus.CREATED)
                )
                  return !1
                if (!(yield this.join())) return !1
                const n = yield t.getCurrentPDFDoc()
                if (
                  !n ||
                  (null === n || void 0 === n ? void 0 : n.isDestroyed) ||
                  null !== this.openFailedPDFDoc
                ) {
                  yield this.openPDF(e)
                  const n = yield t.getCurrentPDFDoc()
                  this.assertPDFDocPermission(n),
                    t.getEventEmitter().once(m.Event.openFileSuccess, (e) =>
                      s(this, void 0, void 0, function* () {
                        yield this.removeAllOriginalAnnotations(e)
                      })
                    )
                } else
                  this.assertPDFDocPermission(n),
                    yield this.removeAllOriginalAnnotations(n)
                const o = yield (0, c.startCollaboration)(this.id, y.context)
                return (
                  (this.context.currentDocId = this.id),
                  (this.context.wsInstance = o),
                  this.context.webSdkBinding.sdkAnnotEventService.initYDoc(),
                  this.context.webSdkBinding.sdkCollabService.observeYDoc(),
                  yield this.context.webSdkBinding.sdkAnnotEventService.initProviders(
                    this.id
                  ),
                  this.context.webSdkBinding.sdkAnnotEventService.addAnnotationListener(),
                  this.context.webSdkBinding.mousePointerService.start(
                    o,
                    this.id
                  ),
                  this.context.pdfViewer.setUserName(
                    this.context.currentUser.username
                  ),
                  (this.collabStatus = a.CollabStatus.BEGIN),
                  !0
                )
              })
            }
            end() {
              return s(this, void 0, void 0, function* () {
                if (this.collabStatus !== a.CollabStatus.BEGIN) return !1
                if ('owner' !== this.userAccessType) return !1
                const e = this.context.sessionId
                if (this.needToClosePDFDoc) {
                  this.context.pdfViewer.close()
                }
                return (
                  yield (0, c.stopCollaboration)(this.id),
                  yield d.deleteDocument(this.id, e),
                  (this.collabStatus = a.CollabStatus.ENDED),
                  !0
                )
              })
            }
            addMembers(e) {
              return s(this, void 0, void 0, function* () {
                if (this.collabStatus === a.CollabStatus.ENDED) return !1
                if (
                  (e || (0, f.throwParamRequiredError)('members'),
                  'member' === this.userAccessType && !this.isDocPublic)
                )
                  return !1
                const t = this.context.sessionId
                return yield d.addDocMembers(this.id, t, e), !0
              })
            }
            getMembers() {
              return s(this, void 0, void 0, function* () {
                return (
                  this.collabStatus === a.CollabStatus.ENDED &&
                    (0, f.throwByCollabStatus)(this.collabStatus),
                  (yield d.getDocMembers(this.id)).map(
                    (e) => new v.Member(e, y.context)
                  )
                )
              })
            }
            updatePermission(e) {
              return s(this, void 0, void 0, function* () {
                let t = yield this.getPermission()
                if (this.collabStatus === a.CollabStatus.ENDED) return !1
                if (
                  (e || (0, f.throwParamRequiredError)('permissionOption'),
                  'owner' !== this.userAccessType)
                )
                  return !1
                let n = t.permission
                const { isDocPublic: o, isAllowComment: r } = e
                if (void 0 !== o && void 0 !== r) {
                  let i = r
                    ? u.DOC_ACTION_PERMISSION.allowComment
                    : u.DOC_ACTION_PERMISSION.onlyView
                  return (
                    (n =
                      (o
                        ? u.DOC_ACCESS_PERMISSION.allowAnyone
                        : u.DOC_ACCESS_PERMISSION.allowMembers) + i),
                    yield d.editDocument(this.id, {
                      isDocPublic: o,
                      permission: n,
                    }),
                    (this.isDocPublic = e.isDocPublic),
                    (t.permission = n),
                    !0
                  )
                }
                if (void 0 !== o && void 0 === r) {
                  let r = t.isAllowComment()
                    ? u.DOC_ACTION_PERMISSION.allowComment
                    : u.DOC_ACTION_PERMISSION.onlyView
                  return (
                    (n =
                      (o
                        ? u.DOC_ACCESS_PERMISSION.allowAnyone
                        : u.DOC_ACCESS_PERMISSION.allowMembers) + r),
                    yield d.editDocument(this.id, {
                      isDocPublic: o,
                      permission: n,
                    }),
                    (this.isDocPublic = e.isDocPublic),
                    (t.permission = n),
                    !0
                  )
                }
                if (void 0 === o && void 0 !== r) {
                  let e = r
                    ? u.DOC_ACTION_PERMISSION.allowComment
                    : u.DOC_ACTION_PERMISSION.onlyView
                  return (
                    (n =
                      (t.isAllowAnyone()
                        ? u.DOC_ACCESS_PERMISSION.allowAnyone
                        : u.DOC_ACCESS_PERMISSION.allowMembers) + e),
                    yield d.editDocument(this.id, { permission: n }),
                    (t.permission = n),
                    !0
                  )
                }
                return !0
              })
            }
            updateMemberPermission(e) {
              return s(this, void 0, void 0, function* () {
                if (this.collabStatus === a.CollabStatus.ENDED) return !1
                if (
                  (e || (0, f.throwParamRequiredError)('members'),
                  e[0].hasOwnProperty('id') ||
                    (0, f.throwParamRequiredError)('id'),
                  e[0].hasOwnProperty('isAllowComment') ||
                    (0, f.throwParamRequiredError)('isAllowComment'),
                  'owner' !== this.userAccessType)
                )
                  return !1
                const t = this.context.sessionId
                return (
                  yield d.editDocMembers(this.id, t, {
                    members: e,
                    emails: [],
                  }),
                  !0
                )
              })
            }
            removeMembers(e) {
              return s(this, void 0, void 0, function* () {
                if (this.collabStatus !== a.CollabStatus.BEGIN) return !1
                if (
                  (e || (0, f.throwParamRequiredError)('members'),
                  e[0].hasOwnProperty('id') ||
                    (0, f.throwParamRequiredError)('id'),
                  'owner' !== this.userAccessType)
                )
                  return !1
                const t = this.context.sessionId
                try {
                  yield d.deleteDocMembers(
                    this.id,
                    t,
                    e.map(({ id: e }) => e)
                  )
                } catch (n) {
                  return !1
                }
                return !0
              })
            }
            quit() {
              return s(this, void 0, void 0, function* () {
                if (this.collabStatus !== a.CollabStatus.BEGIN) return !1
                if ('member' !== this.userAccessType) return !1
                const e = this.context.currentUser.id,
                  t = this.context.sessionId
                return (
                  yield d.deleteDocMembers(this.id, t, [e]),
                  (this.collabStatus = a.CollabStatus.ENDED),
                  !0
                )
              })
            }
            getOnlineMembers() {
              return s(this, void 0, void 0, function* () {
                return (yield d.getDocOnlineMembers(this.id)).map(
                  (e) => new v.Member(e, y.context)
                )
              })
            }
            getPermission() {
              return s(this, void 0, void 0, function* () {
                return (
                  this.collabStatus === a.CollabStatus.ENDED &&
                    (0, f.throwByCollabStatus)(this.collabStatus),
                  this.context.permission
                )
              })
            }
            on(e, t) {
              this.collabStatus === a.CollabStatus.ENDED &&
                (0, f.throwByCollabStatus)(this.collabStatus),
                (this.context.listener = (e) =>
                  s(this, void 0, void 0, function* () {
                    var n, o
                    const { type: r, data: i } = e,
                      s =
                        r === h.DocumentAction.MEMBER_ONLINE
                          ? 'member-online'
                          : r === h.DocumentAction.MEMBER_OFFLINE
                          ? 'member-offline'
                          : r
                    if (s !== p.ScreenSyncEvent.CREATED) {
                      if (s === p.ScreenSyncEvent.STOPPED)
                        return (
                          i.leader.id === this.context.currentUser.id &&
                            this.context.webSdkBinding.sdkScreenSyncService.removeScreenSyncListener(),
                          void t(i, s)
                        )
                      if (s === p.ScreenSyncEvent.MEMBER_JOINED)
                        return (
                          i.leader.id ===
                            (null === (o = this.context.currentUser) ||
                            void 0 === o
                              ? void 0
                              : o.id) &&
                            this.context.webSdkBinding.sdkScreenSyncService.addscreenSyncListener(
                              i.screenSyncId,
                              i.leader.id
                            ),
                          void t(i, s)
                        )
                      if (s === p.ScreenSyncEvent.MEMBER_LEAVE) {
                        let e = this.context.currentUser.id
                        return (
                          i.creatorId !== e &&
                            i.leader.id === e &&
                            0 === i.followerNumber &&
                            this.context.webSdkBinding.sdkScreenSyncService.removeScreenSyncListener(),
                          void t(
                            {
                              screenSyncId: i.screenSyncId,
                              leader: i.leader,
                              member: i.member,
                            },
                            s
                          )
                        )
                      }
                      s !== p.ScreenSyncEvent.SCREENSYNC_DATA
                        ? s !== h.DocumentAction.DELETE_MEMBERS ||
                          this.context.sessionId === i.session_id
                          ? s !== h.DocumentAction.DELETE_SHARE
                            ? s !== h.DocumentAction.EDIT_MEMBERS
                              ? s !==
                                  h.NetworkConnectionEvent
                                    .NetworkConnectionUp &&
                                s !==
                                  h.NetworkConnectionEvent.NetworkConnectionDown
                                ? d
                                    .queryDocMembers(i.docId, [
                                      Number(i.user_id),
                                    ])
                                    .then((e) => {
                                      t(e, s)
                                    })
                                : t(i, s)
                              : -1 !==
                                  i.members.indexOf(
                                    this.context.currentUser.id
                                  ) && t({ collaborationId: i.docId }, s)
                            : t({ collaborationId: i.docId }, s)
                          : t(i.members, s)
                        : this.context.webSdkBinding.sdkScreenSyncService.sync(
                            i
                          )
                    } else i.leader.id !== (null === (n = this.context.currentUser) || void 0 === n ? void 0 : n.id) && t(i, s)
                  }))
            }
            off() {
              return s(this, void 0, void 0, function* () {
                return (
                  this.collabStatus === a.CollabStatus.ENDED &&
                    (0, f.throwByCollabStatus)(this.collabStatus),
                  (this.context.listener = void 0),
                  !0
                )
              })
            }
            createScreenSync(e) {
              return s(this, void 0, void 0, function* () {
                let t = yield l.createScreenSync(
                  this.id,
                  this.context.sessionId,
                  e
                )
                return new g.ScreenSync(this.context, t)
              })
            }
            getScreenSync(e) {
              return s(this, void 0, void 0, function* () {
                if (
                  (e || (0, f.throwParamRequiredError)('screenSyncId'),
                  !/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/.test(e))
                )
                  throw new Error('screenSyncId Format error')
                let t = yield l.getScreenSync(e)
                return new g.ScreenSync(this.context, t)
              })
            }
            getScreenSyncList() {
              return s(this, void 0, void 0, function* () {
                let e = yield l.getScreenSyncList(
                  this.id,
                  this.context.sessionId
                )
                return e
                  ? e.map((e) => new g.ScreenSync(this.context, e))
                  : null
              })
            }
            getCurrentUser() {
              return s(this, void 0, void 0, function* () {
                let e = (yield d.getDocMembers(this.id)).filter((e) => {
                  var t
                  return (
                    e.id ===
                    (null === (t = this.context.currentUser) || void 0 === t
                      ? void 0
                      : t.id)
                  )
                })
                return new v.Member(e[0], this.context)
              })
            }
            getAnnotJSON(e, t) {
              var n
              let o =
                null === (n = this.context.webSdkBinding) || void 0 === n
                  ? void 0
                  : n.sdkAnnotEventService.ydoc
              if (!o) return null
              let r = o.getMap('pageAnnotMaps')
              if (!r) return null
              let i = r.get(t.toString())
              if (!i) return null
              let s = i.get(e.toString() + `__${t}`)
              return s ? s.toJSON() : null
            }
            setMousePointerSyncRate(e) {
              var t
              if (isNaN(Number(e))) throw new Error('invalid syncRate value')
              if (e < 0) throw new Error('invalid syncRate value')
              return (
                null === (t = this.context.webSdkBinding) ||
                  void 0 === t ||
                  t.mousePointerService.setSyncRate(e),
                !0
              )
            }
          }
        },
        5285: (e, t) => {
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.context = void 0),
            (t.context = {
              transport: {
                httpBaseURL: 'http://localhost:8080',
                websocketURL: 'ws//localhost:8080/ws',
              },
            })
        },
        1096: function (e, t, n) {
          var o =
              (this && this.__createBinding) ||
              (Object.create
                ? function (e, t, n, o) {
                    void 0 === o && (o = n)
                    var r = Object.getOwnPropertyDescriptor(t, n)
                    ;(r &&
                      !('get' in r
                        ? !t.__esModule
                        : r.writable || r.configurable)) ||
                      (r = {
                        enumerable: !0,
                        get: function () {
                          return t[n]
                        },
                      }),
                      Object.defineProperty(e, o, r)
                  }
                : function (e, t, n, o) {
                    void 0 === o && (o = n), (e[o] = t[n])
                  }),
            r =
              (this && this.__setModuleDefault) ||
              (Object.create
                ? function (e, t) {
                    Object.defineProperty(e, 'default', {
                      enumerable: !0,
                      value: t,
                    })
                  }
                : function (e, t) {
                    e.default = t
                  }),
            i =
              (this && this.__importStar) ||
              function (e) {
                if (e && e.__esModule) return e
                var t = {}
                if (null != e)
                  for (var n in e)
                    'default' !== n &&
                      Object.prototype.hasOwnProperty.call(e, n) &&
                      o(t, e, n)
                return r(t, e), t
              },
            s =
              (this && this.__awaiter) ||
              function (e, t, n, o) {
                return new (n || (n = Promise))(function (r, i) {
                  function s(e) {
                    try {
                      c(o.next(e))
                    } catch (t) {
                      i(t)
                    }
                  }
                  function a(e) {
                    try {
                      c(o.throw(e))
                    } catch (t) {
                      i(t)
                    }
                  }
                  function c(e) {
                    var t
                    e.done
                      ? r(e.value)
                      : ((t = e.value),
                        t instanceof n
                          ? t
                          : new n(function (e) {
                              e(t)
                            })).then(s, a)
                  }
                  c((o = o.apply(e, t || [])).next())
                })
              }
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.Member = void 0)
          const a = i(n(5741))
          t.Member = class {
            constructor(e, t) {
              ;(this.id = e.id),
                (this.userName = e.userName),
                (this.email = e.email),
                (this.isAllowComment = e.isAllowComment),
                (this.isInScreenSync = e.isInScreenSync),
                (this.lastRead = e.lastRead),
                (this.context = t)
            }
            getScreenSyncInfo() {
              return s(this, void 0, void 0, function* () {
                let e = yield a.getScreenSyncByMemberId(
                    this.context.sessionId,
                    this.context.currentDocId,
                    this.id
                  ),
                  t = e.members.length - 1
                return { id: e.id, followers: t }
              })
            }
          }
        },
        3933: function (e, t, n) {
          var o =
              (this && this.__createBinding) ||
              (Object.create
                ? function (e, t, n, o) {
                    void 0 === o && (o = n)
                    var r = Object.getOwnPropertyDescriptor(t, n)
                    ;(r &&
                      !('get' in r
                        ? !t.__esModule
                        : r.writable || r.configurable)) ||
                      (r = {
                        enumerable: !0,
                        get: function () {
                          return t[n]
                        },
                      }),
                      Object.defineProperty(e, o, r)
                  }
                : function (e, t, n, o) {
                    void 0 === o && (o = n), (e[o] = t[n])
                  }),
            r =
              (this && this.__setModuleDefault) ||
              (Object.create
                ? function (e, t) {
                    Object.defineProperty(e, 'default', {
                      enumerable: !0,
                      value: t,
                    })
                  }
                : function (e, t) {
                    e.default = t
                  }),
            i =
              (this && this.__importStar) ||
              function (e) {
                if (e && e.__esModule) return e
                var t = {}
                if (null != e)
                  for (var n in e)
                    'default' !== n &&
                      Object.prototype.hasOwnProperty.call(e, n) &&
                      o(t, e, n)
                return r(t, e), t
              },
            s =
              (this && this.__awaiter) ||
              function (e, t, n, o) {
                return new (n || (n = Promise))(function (r, i) {
                  function s(e) {
                    try {
                      c(o.next(e))
                    } catch (t) {
                      i(t)
                    }
                  }
                  function a(e) {
                    try {
                      c(o.throw(e))
                    } catch (t) {
                      i(t)
                    }
                  }
                  function c(e) {
                    var t
                    e.done
                      ? r(e.value)
                      : ((t = e.value),
                        t instanceof n
                          ? t
                          : new n(function (e) {
                              e(t)
                            })).then(s, a)
                  }
                  c((o = o.apply(e, t || [])).next())
                })
              }
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.ScreenSync = void 0)
          const a = i(n(5741)),
            c = n(1096)
          t.ScreenSync = class {
            constructor(e, t) {
              ;(this.id = t.id), (this.leader = t.leader), (this.context = e)
            }
            getMembers(e) {
              return s(this, void 0, void 0, function* () {
                let t = yield a.getScreenSyncMembers(this.id, e)
                return t ? t.map((e) => new c.Member(e, this.context)) : null
              })
            }
            join() {
              return s(this, void 0, void 0, function* () {
                return yield a.joinScreenSync(this.id)
              })
            }
            leave() {
              var e
              return s(this, void 0, void 0, function* () {
                return (
                  (yield a.leaveScreenSync(this.id)) &&
                    (this.leader.id ===
                    (null === (e = this.context.currentUser) || void 0 === e
                      ? void 0
                      : e.id)
                      ? this.context.webSdkBinding.sdkScreenSyncService.removeScreenSyncListener()
                      : this.context.webSdkBinding.sdkScreenSyncService.leaveScreenSync()),
                  !0
                )
              })
            }
            setSyncRate(e) {
              var t
              if (isNaN(Number(e))) throw new Error('invalid syncRate value')
              if (e < 0) throw new Error('invalid syncRate value')
              return (
                null === (t = this.context.webSdkBinding) ||
                  void 0 === t ||
                  t.sdkScreenSyncService.setSyncRate(e),
                !0
              )
            }
          }
        },
        971: function (e, t, n) {
          var o =
              (this && this.__createBinding) ||
              (Object.create
                ? function (e, t, n, o) {
                    void 0 === o && (o = n)
                    var r = Object.getOwnPropertyDescriptor(t, n)
                    ;(r &&
                      !('get' in r
                        ? !t.__esModule
                        : r.writable || r.configurable)) ||
                      (r = {
                        enumerable: !0,
                        get: function () {
                          return t[n]
                        },
                      }),
                      Object.defineProperty(e, o, r)
                  }
                : function (e, t, n, o) {
                    void 0 === o && (o = n), (e[o] = t[n])
                  }),
            r =
              (this && this.__setModuleDefault) ||
              (Object.create
                ? function (e, t) {
                    Object.defineProperty(e, 'default', {
                      enumerable: !0,
                      value: t,
                    })
                  }
                : function (e, t) {
                    e.default = t
                  }),
            i =
              (this && this.__importStar) ||
              function (e) {
                if (e && e.__esModule) return e
                var t = {}
                if (null != e)
                  for (var n in e)
                    'default' !== n &&
                      Object.prototype.hasOwnProperty.call(e, n) &&
                      o(t, e, n)
                return r(t, e), t
              },
            s =
              (this && this.__awaiter) ||
              function (e, t, n, o) {
                return new (n || (n = Promise))(function (r, i) {
                  function s(e) {
                    try {
                      c(o.next(e))
                    } catch (t) {
                      i(t)
                    }
                  }
                  function a(e) {
                    try {
                      c(o.throw(e))
                    } catch (t) {
                      i(t)
                    }
                  }
                  function c(e) {
                    var t
                    e.done
                      ? r(e.value)
                      : ((t = e.value),
                        t instanceof n
                          ? t
                          : new n(function (e) {
                              e(t)
                            })).then(s, a)
                  }
                  c((o = o.apply(e, t || [])).next())
                })
              }
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.WebCollabClient = void 0)
          const a = n(7430),
            c = i(n(6989)),
            d = n(7857),
            l = n(9332),
            u = n(4255),
            h = n(5285),
            f = n(6989)
          t.WebCollabClient = class {
            constructor(e) {
              ;(this.sessionId = (0, a.slug)()),
                (h.context.pdfViewer = e.pdfViewer),
                (h.context.transport = (0, u.getTransportConfigFromBaseURL)(
                  e.baseURL
                )),
                (h.context.token = e.userProvider().token),
                (h.context.currentUser = e.userProvider()),
                (h.context.sessionId = this.sessionId),
                (h.context.webSdkBinding = new d.WebSdkBinding(
                  e.pdfViewer,
                  h.context
                ))
            }
            createCollaboration(e) {
              return s(this, void 0, void 0, function* () {
                this.validateDocParam(e)
                const { id: t } = yield c.createDocument(e)
                h.context.currentDocId = t
                const n = yield c.getDocument(t)
                return (
                  yield h.context.webSdkBinding.sdkCollabService.uploadInitialAnnots(),
                  new l.Collaboration(n, h.context)
                )
              })
            }
            validateDocParam(e) {
              e.fileUrl.trim() || (0, u.throwParamRequiredError)('fileUrl'),
                e.hasOwnProperty('isDocPublic') ||
                  (0, u.throwParamRequiredError)('isDocPublic'),
                e.docName.trim() || (0, u.throwParamRequiredError)('docName')
            }
            getCollaborationList() {
              return s(this, void 0, void 0, function* () {
                return (yield c.getAllDocuments()).map(
                  (e) => new l.Collaboration(e, h.context)
                )
              })
            }
            getCollaboration(e) {
              return s(this, void 0, void 0, function* () {
                this.validateCollaborationId(e)
                const t = yield c.getDocument(e)
                return new l.Collaboration(t, h.context)
              })
            }
            validateCollaborationId(e) {
              if (
                (e || (0, u.throwParamRequiredError)('collaborationId'),
                !/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/.test(e))
              )
                throw new Error('collaborationId Format error')
            }
            removeCollaboration(e) {
              return s(this, void 0, void 0, function* () {
                this.validateCollaborationId(e)
                try {
                  return yield c.deleteDocument(e, this.sessionId), !0
                } catch (t) {
                  return console.log(t), !1
                }
              })
            }
            createInvitation(e, t) {
              return s(this, void 0, void 0, function* () {
                return (
                  this.validateCollaborationId(e),
                  yield c.createInvitation(e, t)
                )
              })
            }
            joinCollaborationWithInvitation(e) {
              return s(this, void 0, void 0, function* () {
                ;(e && '' !== e.trim()) ||
                  (0, u.throwParamRequiredError)('invitationId')
                const { id: t } = yield c.getDocIdByInvitation(e)
                return yield this.getCollaboration(t)
              })
            }
            getVersion() {
              return s(this, void 0, void 0, function* () {
                return {
                  'collaboration server': {
                    version: yield (0, f.getCollabServerVersion)(),
                  },
                  'collaboration client': { version: '00fefa47@release/1_2_0' },
                }
              })
            }
          }
        },
        6814: function (e, t, n) {
          var o =
            (this && this.__importDefault) ||
            function (e) {
              return e && e.__esModule ? e : { default: e }
            }
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.LoggerFactory =
              t.ScreenSync =
              t.Collaboration =
              t.Permission =
              t.WebCollabClient =
                void 0)
          var r = n(971)
          Object.defineProperty(t, 'WebCollabClient', {
            enumerable: !0,
            get: function () {
              return r.WebCollabClient
            },
          })
          var i = n(9170)
          Object.defineProperty(t, 'Permission', {
            enumerable: !0,
            get: function () {
              return i.Permission
            },
          })
          var s = n(9332)
          Object.defineProperty(t, 'Collaboration', {
            enumerable: !0,
            get: function () {
              return s.Collaboration
            },
          })
          var a = n(3933)
          Object.defineProperty(t, 'ScreenSync', {
            enumerable: !0,
            get: function () {
              return a.ScreenSync
            },
          })
          var c = n(2733)
          Object.defineProperty(t, 'LoggerFactory', {
            enumerable: !0,
            get: function () {
              return o(c).default
            },
          })
        },
        314: (e, t, n) => {
          Object.defineProperty(t, '__esModule', { value: !0 })
          const o = n(1456)
          t.default = class {
            format(e, t, n) {
              const o = new Error().stack
              let r
              if (o) {
                r = '\n  ' + o.split('\n')[4].trim()
              }
              return [
                {
                  type: 'string',
                  style: `color: ${this.levelColor(t)};`,
                  value: `[${this.levelText(t)}]`,
                },
                { type: 'string', style: 'color: magenta', value: `{${e}}` },
              ]
                .concat(
                  n.map((e) =>
                    void 0 === e || null === e
                      ? {
                          type: typeof e,
                          style: 'color: megenta;font-weight: bold',
                          value: e + '',
                        }
                      : 'string' === typeof e
                      ? {
                          type: typeof e,
                          style: `color: ${this.levelColor(t)}`,
                          value: e,
                        }
                      : { type: typeof e, value: e }
                  )
                )
                .concat({ type: 'string', style: 'color: grey;', value: r })
            }
            levelColor(e) {
              switch (e) {
                case o.LEVEL_DEBUG:
                  return 'blue'
                case o.LEVEL_INFO:
                  return 'green'
                case o.LEVEL_WARN:
                  return '#5C3C00'
                case o.LEVEL_ERROR:
                  return 'red'
              }
              return '#000'
            }
            levelText(e) {
              switch (e) {
                case o.LEVEL_DEBUG:
                  return 'DEBUG'
                case o.LEVEL_INFO:
                  return 'INFO'
                case o.LEVEL_WARN:
                  return 'WARN'
                case o.LEVEL_ERROR:
                  return 'ERROR'
              }
              return 'UNKNOWN LEVEL'
            }
          }
        },
        9624: (e, t, n) => {
          Object.defineProperty(t, '__esModule', { value: !0 })
          const o = n(1456)
          t.default = class {
            print(e, t) {
              const n = e
                  .map((e) => ('string' !== e.type ? ' %o' : ' %c' + e.value))
                  .join('')
                  .trim(),
                r = e.map((e) => ('string' === e.type ? e.style : e.value))
              switch ((r.splice(0, 0, n), t)) {
                case o.LEVEL_DEBUG:
                  console.debug(...r)
                  break
                case o.LEVEL_INFO:
                  console.info(...r)
                  break
                case o.LEVEL_WARN:
                  console.warn(...r)
                  break
                case o.LEVEL_ERROR:
                  console.error(...r)
                  break
                default:
                  console.log(...r)
              }
            }
          }
        },
        5403: (e, t, n) => {
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.NoLogger = void 0)
          const o = n(1456),
            r = n(3631)
          class i {
            constructor(e, t, n) {
              ;(this.appender = e),
                (this.layout = t),
                (this.module = n),
                (this.logOff = !1),
                (this.appender = e),
                (this.layout = t),
                (this.module = n),
                (this.logOff = !1)
            }
            getMinLevel() {
              return void 0 === this.minLevel
                ? r.config.logLevel
                : this.minLevel
            }
            toggle(e) {
              this.logOff = 'boolean' === typeof e ? e : !this.logOff
            }
            setLevel(e) {
              this.minLevel = e
            }
            doLog(e, t) {
              if (this.isLogOff(e)) return
              const n = this.layout.format(this.module, e, t)
              this.appender.print(n, e)
            }
            log(e, ...t) {
              this.doLog(e, t)
            }
            debug(...e) {
              this.doLog(o.LEVEL_DEBUG, e)
            }
            info(...e) {
              this.doLog(o.LEVEL_INFO, e)
            }
            warn(...e) {
              this.doLog(o.LEVEL_WARN, e)
            }
            error(...e) {
              this.doLog(o.LEVEL_ERROR, e)
            }
            isLogOff(e) {
              return this.logOff || r.config.logOff || e < this.getMinLevel()
            }
          }
          t.default = i
          t.NoLogger = class extends i {
            doLog() {}
          }
        },
        2733: function (e, t, n) {
          var o =
            (this && this.__importDefault) ||
            function (e) {
              return e && e.__esModule ? e : { default: e }
            }
          Object.defineProperty(t, '__esModule', { value: !0 })
          const r = o(n(8489)),
            i = o(n(5403)),
            s = o(n(9624)),
            a = o(n(314)),
            c = o(n(524)),
            d = n(3631),
            l = n(7373),
            u = {}
          t.default = class {
            constructor() {}
            static enableLogger(e) {
              ;(0, d.toggleLogOff)(!e)
            }
            static setLogLevel(e) {
              ;(0, d.setLogLevel)(e)
            }
            static getLogger(e) {
              return (u[e] = u[e] || this.createLogger(e))
            }
            static createLogger(e) {
              let t
              if ('complex' === d.config.logLayout) t = new a.default()
              else t = new r.default()
              const n = d.config.logAppenders.map((e) => {
                switch (e) {
                  case 'console':
                  default:
                    return new s.default()
                  case 'websocket':
                    return new l.WebsocketAppender()
                }
              })
              return new i.default(new c.default(n), t, e)
            }
          }
        },
        9594: function (e, t, n) {
          var o =
            (this && this.__importDefault) ||
            function (e) {
              return e && e.__esModule ? e : { default: e }
            }
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.LOGGER = void 0)
          const r = o(n(2733))
          t.LOGGER = r.default.getLogger('collab-client')
        },
        524: (e, t) => {
          Object.defineProperty(t, '__esModule', { value: !0 })
          t.default = class {
            constructor(e = []) {
              this.appenders = e
            }
            print(e, t) {
              this.appenders.forEach((n) => n.print(e, t))
            }
          }
        },
        8489: (e, t, n) => {
          Object.defineProperty(t, '__esModule', { value: !0 })
          const o = n(1456)
          t.default = class {
            format(e, t, n) {
              return [
                { type: 'string', value: `[${this.levelText(t)}]` },
                { type: 'string', value: `{${e}}` },
              ].concat(
                n.map((e) =>
                  void 0 === e || null === e
                    ? { type: typeof e, value: e + '' }
                    : { type: typeof e, value: e }
                )
              )
            }
            levelText(e) {
              switch (e) {
                case o.LEVEL_DEBUG:
                  return 'DEBUG'
                case o.LEVEL_INFO:
                  return 'INFO'
                case o.LEVEL_WARN:
                  return 'WARN'
                case o.LEVEL_ERROR:
                  return 'ERROR'
              }
              return 'UNKNOWN LEVEL'
            }
          }
        },
        7373: (e, t) => {
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.WebsocketAppender = void 0)
          t.WebsocketAppender = class {
            constructor() {
              throw new Error('Unsupported appender: "websocket"')
            }
            print(e, t) {}
          }
        },
        3631: (e, t, n) => {
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.toggleLogOff =
              t.setLogLevel =
              t.strLogLevel2Num =
              t.config =
                void 0)
          const o = n(1456)
          function r(e) {
            switch (e) {
              case 'debug':
                return o.LEVEL_DEBUG
              case 'info':
                return o.LEVEL_INFO
              case 'warn':
                return o.LEVEL_WARN
              default:
                return o.LEVEL_ERROR
            }
          }
          function i(e) {
            const n = r(e)
            switch (n) {
              case o.LEVEL_DEBUG:
              case o.LEVEL_INFO:
              case o.LEVEL_WARN:
              case o.LEVEL_ERROR:
                t.config.logLevel = n
            }
          }
          function s(e) {
            t.config.logOff = e
          }
          ;(t.config = {
            logLevel: o.LEVEL_ERROR,
            logLayout: 'simple',
            logAppenders: ['console'],
            logOff: !1,
            setLogLevel: i,
            toggleLogOff: s,
          }),
            (t.strLogLevel2Num = r),
            (t.setLogLevel = i),
            (t.toggleLogOff = s)
        },
        1456: (e, t) => {
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.LEVEL_ERROR =
              t.LEVEL_WARN =
              t.LEVEL_INFO =
              t.LEVEL_DEBUG =
                void 0),
            (t.LEVEL_DEBUG = 0),
            (t.LEVEL_INFO = 2),
            (t.LEVEL_WARN = 4),
            (t.LEVEL_ERROR = 8)
        },
        5692: function (e, t, n) {
          var o =
              (this && this.__createBinding) ||
              (Object.create
                ? function (e, t, n, o) {
                    void 0 === o && (o = n)
                    var r = Object.getOwnPropertyDescriptor(t, n)
                    ;(r &&
                      !('get' in r
                        ? !t.__esModule
                        : r.writable || r.configurable)) ||
                      (r = {
                        enumerable: !0,
                        get: function () {
                          return t[n]
                        },
                      }),
                      Object.defineProperty(e, o, r)
                  }
                : function (e, t, n, o) {
                    void 0 === o && (o = n), (e[o] = t[n])
                  }),
            r =
              (this && this.__setModuleDefault) ||
              (Object.create
                ? function (e, t) {
                    Object.defineProperty(e, 'default', {
                      enumerable: !0,
                      value: t,
                    })
                  }
                : function (e, t) {
                    e.default = t
                  }),
            i =
              (this && this.__importStar) ||
              function (e) {
                if (e && e.__esModule) return e
                var t = {}
                if (null != e)
                  for (var n in e)
                    'default' !== n &&
                      Object.prototype.hasOwnProperty.call(e, n) &&
                      o(t, e, n)
                return r(t, e), t
              },
            s =
              (this && this.__awaiter) ||
              function (e, t, n, o) {
                return new (n || (n = Promise))(function (r, i) {
                  function s(e) {
                    try {
                      c(o.next(e))
                    } catch (t) {
                      i(t)
                    }
                  }
                  function a(e) {
                    try {
                      c(o.throw(e))
                    } catch (t) {
                      i(t)
                    }
                  }
                  function c(e) {
                    var t
                    e.done
                      ? r(e.value)
                      : ((t = e.value),
                        t instanceof n
                          ? t
                          : new n(function (e) {
                              e(t)
                            })).then(s, a)
                  }
                  c((o = o.apply(e, t || [])).next())
                })
              }
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.IndexeddbPersistence =
              t.clearDocument =
              t.storeState =
              t.fetchUpdates =
              t.PREFERRED_TRIM_SIZE =
                void 0)
          const a = i(n(9703)),
            c = i(n(297)),
            d = n(5750),
            l = 'custom',
            u = 'updates'
          t.PREFERRED_TRIM_SIZE = 500
          t.fetchUpdates = (e, t) =>
            s(void 0, void 0, void 0, function* () {
              const [n] = c.transact(e.db, [u]),
                o = yield c.getAll(
                  n,
                  c.createIDBKeyRangeLowerBound(e._dbref, !1)
                )
              t && t(n),
                a.transact(
                  e.doc,
                  () => {
                    o.forEach((t) => a.applyUpdate(e.doc, t))
                  },
                  e,
                  !1
                )
              const r = yield c.getLastKey(n)
              return (e._dbref = r + 1), (e._dbsize = yield c.count(n)), n
            })
          t.storeState = (e, n = !0) =>
            s(void 0, void 0, void 0, function* () {
              const o = yield (0, t.fetchUpdates)(e)
              ;(n || e._dbsize >= t.PREFERRED_TRIM_SIZE) &&
                (yield c.addAutoKey(o, a.encodeStateAsUpdate(e.doc)),
                yield c.del(o, c.createIDBKeyRangeUpperBound(e._dbref, !0)),
                (e._dbsize = yield c.count(o)))
            })
          t.clearDocument = (e) => c.deleteDB(e)
          class h extends d.Observable {
            constructor(e, n) {
              super(),
                (this._dbref = 0),
                (this._dbsize = 0),
                (this._destroyed = !1),
                (this.db = null),
                (this.synced = !1),
                (this._storeTimeout = 1e3),
                (this._storeTimeoutId = null),
                (this._storeUpdate = (e, n) => {
                  if (this.db && n !== this) {
                    const [n] = c.transact(this.db, [u])
                    c.addAutoKey(n, e),
                      ++this._dbsize >= t.PREFERRED_TRIM_SIZE &&
                        (null !== this._storeTimeoutId &&
                          clearTimeout(this._storeTimeoutId),
                        (this._storeTimeoutId = setTimeout(() => {
                          ;(0, t.storeState)(this, !1),
                            (this._storeTimeoutId = null)
                        }, this._storeTimeout)))
                  }
                }),
                (this.destroy = () => (
                  this._storeTimeoutId && clearTimeout(this._storeTimeoutId),
                  this.doc.off('update', this._storeUpdate),
                  this.doc.off('destroy', this.destroy),
                  (this._destroyed = !0),
                  this._db
                    .then((e) => {
                      e.close()
                    })
                    .catch((e) => {
                      this.emit('error', [e, this])
                    })
                )),
                (this.doc = n),
                (this.name = e),
                (this._db = c.openDB(e, (e) =>
                  c.createStores(e, [[u, { autoIncrement: !0 }], [l]])
                )),
                this._db
                  .then((e) => {
                    this.db = e
                    return (0, t.fetchUpdates)(this, (e) =>
                      c.addAutoKey(e, a.encodeStateAsUpdate(n))
                    ).then(
                      () => (
                        this._destroyed ||
                          (this.emit('synced', [this]), (this.synced = !0)),
                        this
                      )
                    )
                  })
                  .catch((e) => {
                    this.emit('error', [e, this])
                  }),
                n.on('update', this._storeUpdate),
                n.on('destroy', this.destroy)
            }
            clearData() {
              return this.destroy().then(() => {
                c.deleteDB(this.name)
              })
            }
            get(e) {
              return this._db.then((t) => {
                const [n] = c.transact(t, [l], 'readonly')
                return c.get(n, e)
              })
            }
            set(e, t) {
              return this._db.then((n) => {
                const [o] = c.transact(n, [l])
                return c.put(o, t, e)
              })
            }
            del(e) {
              return this._db.then((t) => {
                const [n] = c.transact(t, [l])
                return c.del(n, e)
              })
            }
          }
          t.IndexeddbPersistence = h
        },
        5378: (e, t, n) => {
          Object.defineProperty(t, '__esModule', { value: !0 })
          const o = n(6602)
          t.default = class {
            constructor(e, t) {
              let n = 'number' == typeof e ? e : parseInt(e)
              ;(this.permission = -1 == n ? o.DOC_ALL_PERMISSIONS : n),
                (this.userAccessType = t)
            }
            isOwner() {
              return 'owner' === this.userAccessType
            }
            isMember() {
              return 'member' === this.userAccessType
            }
            isAllowComment() {
              return (
                (255 & this.permission) == o.DOC_ACTION_PERMISSION.allowComment
              )
            }
            isAllowAnyone() {
              return (
                (65280 & this.permission) == o.DOC_ACCESS_PERMISSION.allowAnyone
              )
            }
            isAllowMembers() {
              return (
                (65280 & this.permission) ==
                o.DOC_ACCESS_PERMISSION.allowMembers
              )
            }
          }
        },
        6602: (e, t) => {
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.DOC_ACTION_PERMISSION =
              t.DOC_ACCESS_PERMISSION =
              t.USER_ACCESS_TYPE =
              t.DOC_ALL_PERMISSIONS =
                void 0),
            (t.DOC_ALL_PERMISSIONS = 65535),
            (t.USER_ACCESS_TYPE = {
              OWNER: 'owner',
              MEMBER: 'member',
              UNJOINED: 'unjoined',
            }),
            (function (e) {
              ;(e[(e.allowNone = 0)] = 'allowNone'),
                (e[(e.allowAnyone = 65280)] = 'allowAnyone'),
                (e[(e.allowUserJoin = 65024)] = 'allowUserJoin'),
                (e[(e.allowMembers = 64512)] = 'allowMembers')
            })(t.DOC_ACCESS_PERMISSION || (t.DOC_ACCESS_PERMISSION = {})),
            (function (e) {
              ;(e[(e.allowComment = 255)] = 'allowComment'),
                (e[(e.onlyView = 254)] = 'onlyView')
            })(t.DOC_ACTION_PERMISSION || (t.DOC_ACTION_PERMISSION = {}))
        },
        9170: function (e, t, n) {
          var o =
            (this && this.__importDefault) ||
            function (e) {
              return e && e.__esModule ? e : { default: e }
            }
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.USER_ACCESS_TYPE =
              t.DOC_ALL_PERMISSIONS =
              t.DOC_ACTION_PERMISSION =
              t.DOC_ACCESS_PERMISSION =
              t.Permission =
                void 0)
          const r = o(n(5378))
          t.Permission = r.default
          const i = n(6602)
          Object.defineProperty(t, 'DOC_ACCESS_PERMISSION', {
            enumerable: !0,
            get: function () {
              return i.DOC_ACCESS_PERMISSION
            },
          }),
            Object.defineProperty(t, 'DOC_ACTION_PERMISSION', {
              enumerable: !0,
              get: function () {
                return i.DOC_ACTION_PERMISSION
              },
            }),
            Object.defineProperty(t, 'DOC_ALL_PERMISSIONS', {
              enumerable: !0,
              get: function () {
                return i.DOC_ALL_PERMISSIONS
              },
            }),
            Object.defineProperty(t, 'USER_ACCESS_TYPE', {
              enumerable: !0,
              get: function () {
                return i.USER_ACCESS_TYPE
              },
            })
        },
        5221: function (e, t, n) {
          var o =
            (this && this.__importDefault) ||
            function (e) {
              return e && e.__esModule ? e : { default: e }
            }
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.request = t.axiosInstance = void 0)
          const r = o(n(3300)),
            i = n(5285);        
          (t.axiosInstance = r.default.create()),
            t.axiosInstance.interceptors.response.use(
              function (e) {
                return e.data
              },
              function (e) {
                var t, n
                if (e.response.status >= 400 && e.response.status < 500)
                  return null === (t = e.response) || void 0 === t
                    ? void 0
                    : t.data
                throw new Error(
                  (null === (n = e.response) || void 0 === n
                    ? void 0
                    : n.data.message) || e.message
                )
              }
            ),
            t.axiosInstance.interceptors.request.use((e) => {
              const t = i.context.token
              return (
                t && (e.headers.Authorization = `Bearer ${t}`),
                (e.baseURL = i.context.transport.httpBaseURL),
                e
              )
            }),
            (t.request = t.axiosInstance.request)
        },
        6989: function (e, t, n) {
          var o =
            (this && this.__awaiter) ||
            function (e, t, n, o) {
              return new (n || (n = Promise))(function (r, i) {
                function s(e) {
                  try {
                    c(o.next(e))
                  } catch (t) {
                    i(t)
                  }
                }
                function a(e) {
                  try {
                    c(o.throw(e))
                  } catch (t) {
                    i(t)
                  }
                }
                function c(e) {
                  var t
                  e.done
                    ? r(e.value)
                    : ((t = e.value),
                      t instanceof n
                        ? t
                        : new n(function (e) {
                            e(t)
                          })).then(s, a)
                }
                c((o = o.apply(e, t || [])).next())
              })
            }
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.getCollabServerVersion =
              t.getYLogs =
              t.addInitialYLogs =
              t.getDocIdByInvitation =
              t.createInvitation =
              t.deleteAnnotations =
              t.changeAnnotations =
              t.addAnnotations =
              t.getAnnotations =
              t.deleteDocMembers =
              t.getDocOnlineMembers =
              t.queryDocMembers =
              t.getDocMembers =
              t.editDocMembers =
              t.join =
              t.addDocMembers =
              t.editDocument =
              t.deleteDocument =
              t.getDocument =
              t.getAllDocuments =
              t.createDocument =
                void 0)
          const r = n(5221),
            i = n(2093),
            s = n(9170)
          ;(t.createDocument = function (e) {
            return o(this, void 0, void 0, function* () {
              let t = -1
              t =
                (e.isDocPublic
                  ? s.DOC_ACCESS_PERMISSION.allowAnyone
                  : s.DOC_ACCESS_PERMISSION.allowMembers) +
                s.DOC_ACTION_PERMISSION.allowComment
              return (yield (0,
              r.request)({ url: '/api/doc/create', method: 'post', data: { file_url: e.fileUrl, is_public: e.isDocPublic, name: e.docName, permission: t } })).data
            })
          }),
            (t.getAllDocuments = function () {
              return o(this, void 0, void 0, function* () {
                return (yield (0, r.request)({
                  url: '/api/doc/list',
                  method: 'get',
                })).data.map((e) => (0, i.formatDocResult)(e))
              })
            }),
            (t.getDocument = function (e) {
              return o(this, void 0, void 0, function* () {
                const t = yield (0, r.request)({
                    url: `/api/doc/${e}`,
                    method: 'get',
                  }),
                  n = t.data
                return 0 !== t.ret
                  ? Promise.reject(t)
                  : (0, i.formatDocResult)(n)
              })
            }),
            (t.deleteDocument = function (e, t) {
              return o(this, void 0, void 0, function* () {
                let n = `/api/doc/${e}/delete`
                const o = yield (0, r.request)({
                  url: n,
                  method: 'post',
                  params: { session_id: t },
                })
                if (0 !== o.ret) return Promise.reject(o)
                const s = o.data
                return (0, i.formatDocResult)(s)
              })
            }),
            (t.editDocument = function (e, t) {
              return o(this, void 0, void 0, function* () {
                const n = yield (0, r.request)({
                  url: `/api/doc/${e}/edit`,
                  method: 'post',
                  data: { is_public: t.isDocPublic, permission: t.permission },
                })
                return (0, i.formatDocResult)(n.data)
              })
            }),
            (t.addDocMembers = function (e, t, n) {
              return o(this, void 0, void 0, function* () {
                let o = `/api/doc/${e}/add/members`,
                  i = {}
                i =
                  0 != n.length && Object.keys(n[0]).includes('email')
                    ? { emails: n, members: [] }
                    : { emails: [], members: n }
                const s = yield (0, r.request)({
                  url: o,
                  method: 'post',
                  data: i,
                  params: { session_id: t },
                })
                return 0 !== s.ret ? Promise.reject(s) : s.data
              })
            }),
            (t.join = function (e, t) {
              return o(this, void 0, void 0, function* () {
                let n = `/api/doc/${e}/join`
                const o = yield (0, r.request)({
                  url: n,
                  method: 'post',
                  params: { session_id: t },
                })
                return 0 !== o.ret ? Promise.reject(o) : o.data
              })
            }),
            (t.editDocMembers = function (e, t, { members: n, emails: i }) {
              return o(this, void 0, void 0, function* () {
                let o = `/api/doc/${e}/edit/members`,
                  s = { emails: i, members: n }
                const a = yield (0, r.request)({
                  url: o,
                  method: 'post',
                  data: s,
                  params: { session_id: t },
                })
                return 0 !== a.ret ? Promise.reject(a) : a.data
              })
            }),
            (t.getDocMembers = function (e) {
              return o(this, void 0, void 0, function* () {
                const t = yield (0, r.request)({
                  url: `/api/doc/${e}/members`,
                  method: 'get',
                })
                return null == t.data
                  ? []
                  : t.data.map((e) => (0, i.formatUserResult)(e))
              })
            }),
            (t.queryDocMembers = function (e, t) {
              return o(this, void 0, void 0, function* () {
                const n = yield (0, r.request)({
                  url: `/api/doc/${e}/query/members`,
                  method: 'post',
                  data: { members: t },
                })
                return null == n.data
                  ? []
                  : n.data.map((e) => (0, i.formatUserResult)(e))
              })
            }),
            (t.getDocOnlineMembers = function (e) {
              return o(this, void 0, void 0, function* () {
                const t = yield (0, r.request)({
                  url: `/api/doc/${e}/members/online`,
                  method: 'get',
                })
                return null == t.data
                  ? []
                  : t.data.map((e) => (0, i.formatUserResult)(e))
              })
            }),
            (t.deleteDocMembers = function (e, t, n) {
              return o(this, void 0, void 0, function* () {
                let o = { members: n }
                const i = yield (0, r.request)({
                  url: `/api/doc/${e}/delete/members`,
                  method: 'post',
                  data: o,
                  params: { session_id: t },
                })
                return 0 !== i.ret ? Promise.reject(i) : i.data
              })
            }),
            (t.getAnnotations = function (e, t, n = 'in') {
              return o(this, void 0, void 0, function* () {
                let o = `/api/doc/${e}/annotations`
                const s = yield (0, r.request)({
                  url: o,
                  method: 'get',
                  params: { annotation_ids: t, strategy: n },
                })
                return 0 !== s.ret
                  ? Promise.reject(s)
                  : s.data.map((e) => (0, i.formatAnnotationResult)(e))
              })
            }),
            (t.addAnnotations = function (e, t, n, s = !1) {
              return o(this, void 0, void 0, function* () {
                let o = `/api/doc/${e}/add/annotations`,
                  a = {
                    annots: n.map((e) => (0, i.formatAnnotationBean)(e)),
                    is_init: s,
                  }
                const c = yield (0, r.request)({
                  url: o,
                  method: 'post',
                  data: a,
                  params: { session_id: t },
                })
                return 0 !== c.ret ? Promise.reject(c) : c.data
              })
            }),
            (t.changeAnnotations = function (e, t, n) {
              return o(this, void 0, void 0, function* () {
                let o = `/api/doc/${e}/change/annotations`,
                  s = { annots: n.map((e) => (0, i.formatAnnotationBean)(e)) }
                const a = yield (0, r.request)({
                  url: o,
                  method: 'post',
                  data: s,
                  params: { session_id: t },
                })
                return 0 !== a.ret ? Promise.reject(a) : a.data
              })
            }),
            (t.deleteAnnotations = function (e, t, n) {
              return o(this, void 0, void 0, function* () {
                let o = `/api/doc/${e}/delete/annotations`,
                  i = {
                    annots: n.map(({ annotationId: e, pageNumber: t }) => ({
                      annotation_id: e,
                      page_number: t,
                    })),
                  }
                const s = yield (0, r.request)({
                  url: o,
                  method: 'post',
                  data: i,
                  params: { session_id: t },
                })
                return 0 !== s.ret ? Promise.reject(s) : s.data
              })
            }),
            (t.createInvitation = function (e, t) {
              return o(this, void 0, void 0, function* () {
                let n = `/api/doc/${e}/create/invitation`
                const o = yield (0, r.request)({
                  url: n,
                  method: 'post',
                  data: { expiresInMilliSeconds: t },
                })
                return 0 !== o.ret ? Promise.reject(o) : o.data
              })
            }),
            (t.getDocIdByInvitation = function (e) {
              return o(this, void 0, void 0, function* () {
                let t = `/api/doc/invitation/${e}`
                return (yield (0, r.request)({ url: t, method: 'get' })).data
              })
            }),
            (t.addInitialYLogs = function (e, t) {
              return o(this, void 0, void 0, function* () {
                let n = `/api/doc/${e}/ylogs`
                const o = yield (0, r.request)({
                  url: n,
                  method: 'post',
                  data: { ylog: t },
                })
                return 0 !== o.ret ? Promise.reject(o) : o.data
              })
            }),
            (t.getYLogs = function (e) {
              return o(this, void 0, void 0, function* () {
                let t = `/api/doc/${e}/ylogs`
                const n = yield (0, r.request)({ url: t, method: 'get' })
                return 0 !== n.ret ? Promise.reject(n) : n.data
              })
            }),
            (t.getCollabServerVersion = function () {
              return o(this, void 0, void 0, function* () {
                const e = yield (0, r.request)({
                  url: '/api/version',
                  method: 'get',
                })
                return 0 !== e.ret ? Promise.reject(e) : e.data.version
              })
            })
        },
        2093: (e, t) => {
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.formatUserResult =
              t.formatDocResult =
              t.formatAnnotationBean =
              t.formatAnnotationResult =
                void 0),
            (t.formatAnnotationResult = function (e) {
              const {
                id: t,
                author_id: n,
                annotation_id: o,
                document_id: r,
                page_number: i,
                xfdf: s,
                in_reply_to: a,
              } = e
              return {
                id: t,
                authorId: n,
                annotationId: o,
                documentId: r,
                pageNumber: i,
                xfdf: s,
                inReplyTo: a,
              }
            }),
            (t.formatAnnotationBean = function (e) {
              const {
                id: t,
                authorId: n,
                annotationId: o,
                documentId: r,
                pageNumber: i,
                xfdf: s,
                inReplyTo: a,
              } = e
              return {
                id: t,
                author_id: n,
                annotation_id: o,
                document_id: r,
                page_number: i,
                xfdf: s,
                in_reply_to: a,
              }
            }),
            (t.formatDocResult = function (e) {
              const {
                id: t,
                name: n,
                file_url: o,
                created_at: r,
                author_id: i,
                updated_at: s,
                is_public: a,
                permission: c,
                access: d,
                status: l,
              } = e
              return {
                id: t,
                docName: n,
                fileUrl: o,
                isDocPublic: a,
                authorId: i,
                docPermission: c,
                createdAt: r,
                updatedAt: s,
                access: d,
                status: l,
              }
            }),
            (t.formatUserResult = function (e) {
              const {
                id: t,
                user_name: n,
                email: o,
                status: r,
                type: i,
                isAllowComment: s,
                last_read: a,
                isInScreenSync: c,
              } = e
              return {
                id: t,
                userName: n,
                email: o,
                status: r,
                isAllowComment: s,
                type: i,
                lastRead: a,
                isInScreenSync: c,
              }
            })
        },
        5741: function (e, t, n) {
          var o =
            (this && this.__awaiter) ||
            function (e, t, n, o) {
              return new (n || (n = Promise))(function (r, i) {
                function s(e) {
                  try {
                    c(o.next(e))
                  } catch (t) {
                    i(t)
                  }
                }
                function a(e) {
                  try {
                    c(o.throw(e))
                  } catch (t) {
                    i(t)
                  }
                }
                function c(e) {
                  var t
                  e.done
                    ? r(e.value)
                    : ((t = e.value),
                      t instanceof n
                        ? t
                        : new n(function (e) {
                            e(t)
                          })).then(s, a)
                }
                c((o = o.apply(e, t || [])).next())
              })
            }
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.getScreenSyncMembers =
              t.syncScreenData =
              t.leaveScreenSync =
              t.joinScreenSync =
              t.getScreenSyncList =
              t.getScreenSyncByMemberId =
              t.getScreenSync =
              t.createScreenSync =
                void 0)
          const r = n(5221),
            i = n(2093)
          ;(t.createScreenSync = function (e, t, n) {
            return o(this, void 0, void 0, function* () {
              return (yield (0,
              r.request)({ url: '/api/screen-sync', method: 'post', params: { session_id: t, doc_id: e }, data: { members: n } })).data
            })
          }),
            (t.getScreenSync = function (e) {
              return o(this, void 0, void 0, function* () {
                const t = yield (0, r.request)({
                  url: `/api/screen-sync/${e}`,
                  method: 'get',
                })
                return 0 !== t.ret ? Promise.reject(t) : t.data
              })
            }),
            (t.getScreenSyncByMemberId = function (e, t, n) {
              return o(this, void 0, void 0, function* () {
                const o = yield (0, r.request)({
                  url: '/api/screen-sync',
                  method: 'get',
                  params: { session_id: e, doc_id: t, memberId: n },
                })
                return 0 !== o.ret ? Promise.reject(o) : o.data
              })
            }),
            (t.getScreenSyncList = function (e, t) {
              return o(this, void 0, void 0, function* () {
                return (yield (0,
                r.request)({ url: '/api/screen-sync/list', method: 'get', params: { session_id: t, doc_id: e } })).data
              })
            }),
            (t.joinScreenSync = function (e) {
              return o(this, void 0, void 0, function* () {
                const t = yield (0, r.request)({
                  url: `/api/screen-sync/${e}/join`,
                  method: 'post',
                })
                return 0 !== t.ret ? Promise.reject(t) : t.data
              })
            }),
            (t.leaveScreenSync = function (e) {
              return o(this, void 0, void 0, function* () {
                const t = yield (0, r.request)({
                  url: `/api/screen-sync/${e}/leave`,
                  method: 'post',
                })
                return 0 !== t.ret ? Promise.reject(t) : t.data
              })
            }),
            (t.syncScreenData = function (e, t) {
              return o(this, void 0, void 0, function* () {
                return (yield (0,
                r.request)({ url: `/api/screen-sync/${e}/sync`, method: 'post', data: t })).data
              })
            }),
            (t.getScreenSyncMembers = function (e, t) {
              return o(this, void 0, void 0, function* () {
                return (yield (0, r.request)({
                  url: `/api/screen-sync/${e}/members`,
                  method: 'get',
                  params: { role: t },
                })).data.map((e) => (0, i.formatUserResult)(e))
              })
            })
        },
        5608: (e, t) => {
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.NetworkConnectionEvent =
              t.DocumentAction =
              t.MessageType =
                void 0),
            (function (e) {
              ;(e.HEART = 'heart'),
                (e.SUBSCRIBE_DOC = 'subscribe-doc'),
                (e.UNSUBSCRIBE_DOC = 'unsubscribe-doc')
            })(t.MessageType || (t.MessageType = {})),
            (function (e) {
              ;(e.MEMBER_ONLINE = 'member-online'),
                (e.MEMBER_OFFLINE = 'member-offline'),
                (e.ADD_MEMBERS = 'add-members'),
                (e.DELETE_MEMBERS = 'delete-members'),
                (e.ADD_ANNOTS = 'add-annots'),
                (e.CHANGE_ANNOTS = 'change-annots'),
                (e.DELETE_ANNOTS = 'delete-annots'),
                (e.DELETE_SHARE = 'delete-share'),
                (e.EDIT_MEMBERS = 'edit-members'),
                (e.MOUSE_POINTER_SYNC = 'mouse-pointer-sync'),
                (e.SYNC_YLOG = 'sync-ylog'),
                (e.SYNC_YLOG_STEP_1 = 'sync-ylog-s1'),
                (e.SYNC_YLOG_STEP_2 = 'sync-ylog-s2')
            })(t.DocumentAction || (t.DocumentAction = {})),
            (function (e) {
              ;(e.NetworkConnectionUp = 'network-connection-up'),
                (e.NetworkConnectionDown = 'network-connection-down')
            })(t.NetworkConnectionEvent || (t.NetworkConnectionEvent = {}))
        },
        8037: (e, t) => {
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.CollabStatus = void 0),
            (function (e) {
              ;(e.CREATED = 'CREATED'), (e.BEGIN = 'BEGIN'), (e.ENDED = 'ENDED')
            })(t.CollabStatus || (t.CollabStatus = {}))
        },
        9648: (e, t) => {
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.ScreenSyncEvent = t.PointerStyle = t.ScreenSyncRole = void 0),
            (function (e) {
              ;(e.LEADER = 'leader'), (e.FOLLOWER = 'follower')
            })(t.ScreenSyncRole || (t.ScreenSyncRole = {})),
            (function (e) {
              ;(e.HAND = 'hand'),
                (e.CROSSHAIR = 'crosshair'),
                (e.ARROW = 'arrow'),
                (e.LASTER_POINTER = 'laser-pointer')
            })(t.PointerStyle || (t.PointerStyle = {})),
            (function (e) {
              ;(e.CREATED = 'screen-sync-created'),
                (e.STOPPED = 'screen-sync-stopped'),
                (e.MEMBER_JOINED = 'screen-sync-member-joined'),
                (e.MEMBER_LEAVE = 'screen-sync-member-leave'),
                (e.SCREENSYNC_DATA = 'screen-sync-data')
            })(t.ScreenSyncEvent || (t.ScreenSyncEvent = {}))
        },
        1095: (e, t) => {
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.debounce = t.DebounceTaskExecutor = void 0)
          const n = () => {}
          class o {
            constructor(e = 100, t = !1) {
              ;(this.delay = e),
                (this.leading = t),
                (this.handle = n),
                (this.flag = 0),
                (this.pending = !1)
            }
            exec(e) {
              if ((this.flag++, (this.handle = e), this.pending)) return
              this.leading && (e(), (this.flag = 0), (this.handle = n))
              const t = () => {
                ;(this.pending = !0),
                  setTimeout(() => {
                    if (this.flag > 1) (this.flag = 0), t()
                    else {
                      const e = this.handle
                      ;(this.handle = n), e(), (this.pending = !1)
                    }
                  }, this.delay)
              }
              t()
            }
            cancel() {
              this.handle = n
            }
          }
          ;(t.DebounceTaskExecutor = o),
            (t.debounce = function (e, t = 100, n = !1) {
              const r = new o(t, n)
              return function (...t) {
                const n = e.bind(this, ...t)
                r.exec(n)
              }
            })
        },
        4255: (e, t, n) => {
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.getTransportConfigFromBaseURL =
              t.getScreenSyncInitialInfo =
              t.isObjectValueEqual =
              t.throwByCollabStatus =
              t.throwParamRequiredError =
              t.validateEmail =
                void 0)
          const o = n(8037)
          ;(t.validateEmail = function (e) {
            return /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              e
            )
          }),
            (t.throwParamRequiredError = function (e) {
              throw new Error(`The ${e} parameter is required`)
            }),
            (t.throwByCollabStatus = function (e) {
              switch (e) {
                case o.CollabStatus.BEGIN:
                  throw new Error('The collaboration has begun')
                case o.CollabStatus.ENDED:
                  throw new Error('The collaboration  has ended')
                case o.CollabStatus.CREATED:
                  throw new Error(
                    'The collaboration has been created but not begun'
                  )
              }
            }),
            (t.isObjectValueEqual = function (e, t) {
              var n = Object.getOwnPropertyNames(e),
                o = Object.getOwnPropertyNames(t)
              if (n.length != o.length) return !1
              for (var r = 0; r < n.length; r++) {
                var i = n[r]
                if (e[i] !== t[i]) return !1
              }
              return !0
            }),
            (t.getScreenSyncInitialInfo = function () {
              return {
                defaultScreenSyncData: {
                  zoom: 'fitWidth',
                  layoutMode: 'continuous-page-view-mode',
                  isFullScreenMode: !1,
                  scrollPosition: { x: 0, y: 0 },
                  scale: 1,
                },
              }
            }),
            (t.getTransportConfigFromBaseURL = function (e) {
              const { host: t, protocol: n, pathname: o } = new URL(e)
              let r = `ws://${t}${o}/ws`,
                i = o
              return (
                o.endsWith('/') || (i = i = o + '/'),
                (r = 'http:' === n ? `ws://${t}${i}ws` : `wss://${t}${i}ws`),
                { httpBaseURL: e, websocketURL: r }
              )
            })
        },
        7418: (e, t) => {
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.throttle = void 0),
            (t.throttle = function (e, t = 200, n = {}) {
              let o,
                r,
                i,
                s,
                a = 0
              const c = () => {
                ;(a = !1 === n.leading ? 0 : Date.now()),
                  (o = null),
                  (s = e.apply(r, i)),
                  o || (r = i = null)
              }
              function d() {
                const d = Date.now()
                a || !1 !== n.leading || (a = d)
                const l = t - (d - a)
                return (
                  (r = this),
                  (i = arguments),
                  l <= 0 || l > t
                    ? (o && (clearTimeout(o), (o = null)),
                      (a = d),
                      (s = e.apply(r, i)),
                      o || (r = i = null))
                    : o || !1 === n.trailing || (o = setTimeout(c, l)),
                  s
                )
              }
              return (
                (d.cancel = function () {
                  clearTimeout(o), (a = 0), (o = r = i = null)
                }),
                (d.setThreshold = function (e) {
                  t = e
                }),
                d
              )
            })
        },
        5231: function (e, t, n) {
          var o =
            (this && this.__awaiter) ||
            function (e, t, n, o) {
              return new (n || (n = Promise))(function (r, i) {
                function s(e) {
                  try {
                    c(o.next(e))
                  } catch (t) {
                    i(t)
                  }
                }
                function a(e) {
                  try {
                    c(o.throw(e))
                  } catch (t) {
                    i(t)
                  }
                }
                function c(e) {
                  var t
                  e.done
                    ? r(e.value)
                    : ((t = e.value),
                      t instanceof n
                        ? t
                        : new n(function (e) {
                            e(t)
                          })).then(s, a)
                }
                c((o = o.apply(e, t || [])).next())
              })
            }
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.MousePointerService = void 0)
          const r = n(5608),
            i = n(8907),
            s = n(6526),
            a = n(7418)
          const c = window.PDFViewCtrl
          t.MousePointerService = class {
            constructor(e, t) {
              var n
              ;(this.context = t),
                (this.color = '#222222'),
                (this.mousePointerStates = {}),
                (this.disableSync = !0),
                (this.onMemberOffline = (e) =>
                  o(this, void 0, void 0, function* () {
                    const t = e.user_id
                    if (this.mousePointerStates[t]) {
                      const e = this.mousePointerStates[t].mouseElement
                      null === e || void 0 === e || e.remove(),
                        delete this.mousePointerStates[t]
                    }
                  })),
                (this.refresh = () =>
                  o(this, void 0, void 0, function* () {
                    for (const e of Object.keys(this.mousePointerStates)) {
                      const t = this.mousePointerStates[e]
                      if (!t) continue
                      const { mouseElement: n, mouseData: o } = t,
                        r = this.pdfViewer.getPDFPageRender(0)
                      if (!r) return
                      const i = yield r.transformPoint({
                        point: { x: o.x, y: o.y },
                        srcType: c.constants.PagePointType.pdf,
                        destType: c.constants.PagePointType.scroll,
                      })
                      n
                        ? Object.assign(n.style, {
                            left: i.x + 'px',
                            top: i.y + 'px',
                          })
                        : (t.mouseElement = this.addNode(o))
                    }
                  })),
                (this.pdfViewer = e),
                (this.color = (function (e) {
                  let t = Math.floor(123 * e).toString(16)
                  for (; t.length < 6; ) t = '0' + t
                  return '#' + t
                })(
                  null === (n = t.currentUser) || void 0 === n ? void 0 : n.id
                )),
                (this.context = t),
                (this.onMouseMove = (0, a.throttle)(
                  this.onMouseMove.bind(this)
                ))
            }
            setSyncRate(e) {
              this.onMouseMove.setThreshold(e)
            }
            onMouseMove(e) {
              return o(this, void 0, void 0, function* () {
                const t = this.pdfViewer.getPDFPageRender(0)
                if (!t) return
                const n = yield t.transformPoint({
                  point: { x: e.clientX, y: e.clientY },
                  srcType: c.constants.PagePointType.viewport,
                  destType: c.constants.PagePointType.pdf,
                })
                this.sync(n)
              })
            }
            start(e, t) {
              ;(this.ws = e), (this.docId = t), (this.disableSync = !1)
              const n = this.pdfViewer.getScrollWrap().scrollHost
              n.addEventListener('mousemove', this.onMouseMove),
                n.addEventListener('click', this.onMouseMove)
              const o = this.pdfViewer.addEventListener(
                  i.Event.zoomToSuccess,
                  this.refresh
                ),
                r = setInterval(() => {
                  this.refresh()
                }, 500)
              this.pdfViewer.eventEmitter.once(
                i.Event.willCloseDocument,
                () => {
                  ;(0, s.stopCollaboration)(this.context.currentDocId),
                    n.removeEventListener('mousemove', this.onMouseMove),
                    n.removeEventListener('click', this.onMouseMove),
                    o(),
                    clearInterval(r),
                    this.clean(),
                    (this.disableSync = !0)
                }
              )
            }
            stop() {
              this.disableSync = !0
            }
            sync(e) {
              var t
              const n = {
                event: 'events',
                data: {
                  type: r.DocumentAction.MOUSE_POINTER_SYNC,
                  data: {
                    docId: this.docId,
                    state: Object.assign(Object.assign({}, e), {
                      username:
                        null === (t = this.context.currentUser) || void 0 === t
                          ? void 0
                          : t.username,
                      color: this.color,
                    }),
                  },
                },
              }
              this.ws.send(JSON.stringify(n))
            }
            renderInitialMousePointers(e) {
              return o(this, void 0, void 0, function* () {
                ;(this.disableSync = !1), this.clean()
                for (const t of Object.keys(e))
                  this.mousePointerStates[t] = {
                    mouseElement: null,
                    mouseData: e[t],
                  }
              })
            }
            render({ userId: e, sessionId: t, state: n }) {
              return o(this, void 0, void 0, function* () {
                if (this.disableSync) return
                const t = this.pdfViewer.getPDFPageRender(0)
                if (!t) return
                const o = yield t.transformPoint({
                    point: { x: n.x, y: n.y },
                    srcType: c.constants.PagePointType.pdf,
                    destType: c.constants.PagePointType.scroll,
                  }),
                  r = this.mousePointerStates[e],
                  i = null === r || void 0 === r ? void 0 : r.mouseElement
                i
                  ? ((r.mouseData = {
                      x: n.x,
                      y: n.y,
                      username: n.username,
                      color: n.color,
                    }),
                    Object.assign(i.style, {
                      left: o.x + 'px',
                      top: o.y + 'px',
                    }))
                  : (this.mousePointerStates[e] = {
                      mouseElement: this.addNode(n),
                      mouseData: {
                        x: n.x,
                        y: n.y,
                        username: n.username,
                        color: n.color,
                      },
                    })
              })
            }
            clean() {
              for (const e of Object.keys(this.mousePointerStates)) {
                const t = this.mousePointerStates[e]
                if (!t) continue
                const { mouseElement: n } = t
                null === n || void 0 === n || n.remove(),
                  delete this.mousePointerStates[e]
              }
            }
            addNode(e) {
              const { username: t, color: n } = e,
                o = document.createElement('div')
              Object.assign(o.style, {
                position: 'absolute',
                left: e.x + 'px',
                top: e.y + 'px',
                zIndex: '999',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }),
                (o.innerHTML = `\n      <svg width="10" height="13" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg">\n        <path d="M5.8 8L7.48 11.56C7.56 11.76 7.48 12 7.28 12.08L5.84 12.76C5.64 12.84 5.4 12.76 5.32 12.56L3.6 8.92L1.52 11C1.44 11.08 1.36 11.12 1.24 11.12C0.999996 11.12 0.839996 10.96 0.839996 10.72V0.599999C0.839996 0.519999 0.879996 0.399999 0.959996 0.319999C1.12 0.159999 1.36 0.159999 1.52 0.279999L8.96 7.04C9.04 7.12 9.08 7.2 9.08 7.32C9.08 7.56 8.92 7.72 8.72 7.76L5.8 8Z" fill="${n}"/>\n      </svg>\n      <div style="font-size: 12px;color: #fff;background: ${n};padding: 0 2px; border-radius: 2px;">${t}</div>\n    `)
              return this.pdfViewer.getScrollWrap().scrollHost.appendChild(o), o
            }
          }
        },
        923: function (e, t, n) {
          var o =
              (this && this.__createBinding) ||
              (Object.create
                ? function (e, t, n, o) {
                    void 0 === o && (o = n)
                    var r = Object.getOwnPropertyDescriptor(t, n)
                    ;(r &&
                      !('get' in r
                        ? !t.__esModule
                        : r.writable || r.configurable)) ||
                      (r = {
                        enumerable: !0,
                        get: function () {
                          return t[n]
                        },
                      }),
                      Object.defineProperty(e, o, r)
                  }
                : function (e, t, n, o) {
                    void 0 === o && (o = n), (e[o] = t[n])
                  }),
            r =
              (this && this.__setModuleDefault) ||
              (Object.create
                ? function (e, t) {
                    Object.defineProperty(e, 'default', {
                      enumerable: !0,
                      value: t,
                    })
                  }
                : function (e, t) {
                    e.default = t
                  }),
            i =
              (this && this.__importStar) ||
              function (e) {
                if (e && e.__esModule) return e
                var t = {}
                if (null != e)
                  for (var n in e)
                    'default' !== n &&
                      Object.prototype.hasOwnProperty.call(e, n) &&
                      o(t, e, n)
                return r(t, e), t
              },
            s =
              (this && this.__awaiter) ||
              function (e, t, n, o) {
                return new (n || (n = Promise))(function (r, i) {
                  function s(e) {
                    try {
                      c(o.next(e))
                    } catch (t) {
                      i(t)
                    }
                  }
                  function a(e) {
                    try {
                      c(o.throw(e))
                    } catch (t) {
                      i(t)
                    }
                  }
                  function c(e) {
                    var t
                    e.done
                      ? r(e.value)
                      : ((t = e.value),
                        t instanceof n
                          ? t
                          : new n(function (e) {
                              e(t)
                            })).then(s, a)
                  }
                  c((o = o.apply(e, t || [])).next())
                })
              }
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.SdkAnnotEventService = void 0)
          const a = n(8907),
            c = n(1095),
            d = i(n(9703)),
            l = n(5608),
            u = n(5285),
            h = n(6989),
            f = n(5692),
            p = i(n(7918)),
            v = n(9594)
          t.SdkAnnotEventService = class {
            constructor(e, t) {
              ;(this.addInitialAnnotations = (e) =>
                s(this, void 0, void 0, function* () {
                  for (let r of e) r.getName() || (yield r.setUniqueID())
                  const t = new d.Doc()
                  yield this.encodeAnnotationAdd(e, t)
                  const n = d.encodeStateAsUpdate(t),
                    o = this.context.currentDocId
                  return yield (0, h.addInitialYLogs)(o, n), !0
                })),
                (this.addAnnotation = (e) =>
                  s(this, void 0, void 0, function* () {
                    yield this.encodeAsYDocTypes(e, a.Event.annotationAdded)
                  })),
                (this.addAnnotationReply = (e) =>
                  s(this, void 0, void 0, function* () {
                    const t = [e]
                    yield this.encodeAsYDocTypes(t, a.Event.annotationAdded)
                  })),
                (this.updateAnnotation = (e, t, n) =>
                  s(this, void 0, void 0, function* () {
                    'add-replies' !== n &&
                      'review-state-updated' !== n &&
                      'marked-state-updated' !== n &&
                      (yield this.encodeAsYDocTypes(
                        e,
                        a.Event.annotationUpdated
                      ))
                  })),
                (this.deleteAnnotation = (e) =>
                  s(this, void 0, void 0, function* () {
                    yield this.encodeAsYDocTypes(e, a.Event.annotationRemoved)
                  })),
                (this.annotReviewStateAdd = (e) =>
                  s(this, void 0, void 0, function* () {
                    const t = [e]
                    yield this.encodeAsYDocTypes(t, a.Event.annotationAdded)
                  })),
                (this.willCloseDocument = () => {
                  this.tempRemoveAnnotsUserId = {}
                }),
                (this.pdfViewer = e),
                (this.annotList = []),
                (this.context = t),
                (this.changeViewModeEvent =
                  this.changeViewModeEvent.bind(this)),
                (this.zoomEvent = (0, c.debounce)(
                  this.zoomEvent.bind(this),
                  150
                )),
                (this.tempRemoveAnnotsUserId = {})
            }
            addAnnotationListener() {
              ;(this.removeAddAnnotListener = this.pdfViewer.addEventListener(
                a.Event.annotationAdded,
                this.addAnnotation
              )),
                (this.removeAddAnnotReplyListener =
                  this.pdfViewer.addEventListener(
                    a.Event.annotationReplyAdd,
                    this.addAnnotationReply
                  )),
                (this.removeUpdateAnnotListener =
                  this.pdfViewer.addEventListener(
                    a.Event.annotationUpdated,
                    this.updateAnnotation
                  )),
                (this.removeDeleteAnnotListener =
                  this.pdfViewer.addEventListener(
                    a.Event.annotationRemoved,
                    this.deleteAnnotation
                  )),
                (this.removeAnnotReviewStateAdd =
                  this.pdfViewer.addEventListener(
                    a.Event.annotationReviewStateAnnotAdd,
                    this.annotReviewStateAdd
                  )),
                (this.removeWillCloseDocumentListener =
                  this.pdfViewer.addEventListener(
                    a.Event.willCloseDocument,
                    this.willCloseDocument
                  )),
                (this.removeZoomEvent = this.pdfViewer.addEventListener(
                  a.Event.zoomToSuccess,
                  this.zoomEvent
                )),
                (this.removechangeViewModeEvent =
                  this.pdfViewer.addEventListener(
                    a.Event.changeViewModeSuccess,
                    this.changeViewModeEvent
                  )),
                (this.removeUndoRedoStoreChangeEvent =
                  this.pdfViewer.addEventListener(
                    a.Event.undoRedoStoreChange,
                    (e) => {
                      this.undoRedoManager = e.undoRedoManager
                    }
                  )),
                this.pdfViewer.setContinuousAddPencilState &&
                  this.pdfViewer.setContinuousAddPencilState(!0)
            }
            syncUpdate(e, t = l.DocumentAction.SYNC_YLOG, n) {
              const o = this.context.wsInstance,
                r = n || this.context.currentDocId
              v.LOGGER.debug(
                `sending msg ${t} to server, size: ${
                  null === e || void 0 === e ? void 0 : e.length
                }`,
                { serverId: u.context.serverId }
              )
              const i = { type: t, data: { docId: r, ylog: e } }
              o.send(p.encode(i))
            }
            removeAnnotationListener() {
              this.removeAddAnnotListener(),
                this.removeAddAnnotReplyListener(),
                this.removeUpdateAnnotListener(),
                this.removeDeleteAnnotListener(),
                this.removeAnnotReviewStateAdd(),
                this.removeWillCloseDocumentListener(),
                this.removeZoomEvent(),
                this.removechangeViewModeEvent(),
                this.removeUndoRedoStoreChangeEvent(),
                this.pdfViewer.setContinuousAddPencilState &&
                  this.pdfViewer.setContinuousAddPencilState(!1)
            }
            zoomEvent(e) {
              return s(this, void 0, void 0, function* () {
                yield this.context.webSdkBinding.sdkScreenSyncService.setZoomBySDK(
                  e
                )
              })
            }
            changeViewModeEvent(e) {
              return s(this, void 0, void 0, function* () {
                yield this.context.webSdkBinding.sdkScreenSyncService.setViewModeBySDK(
                  e
                )
              })
            }
            getPageIdByPageIndex(e) {}
            encodeAnnotationAdd(e, t, n) {
              return s(this, void 0, void 0, function* () {
                const o = this.context.currentUser.id,
                  r = this.pdfViewer.getCurrentPDFDoc(),
                  i = this.pdfViewer.getAnnotAuthorityManager(),
                  s = yield r.exportAnnotsToJSON(e),
                  a = t.getMap('pageAnnotMaps')
                t.transact(() => {
                  s.map((t, r) => {
                    const i = t.page.toString()
                    let s = a.get(i)
                    s || ((s = new d.Map()), a.set(i, s))
                    let c = s.get(t.name + `__${i}`)
                    if (!c)
                      if (
                        ((c = new d.Map()),
                        s.set(t.name + `__${i}`, c),
                        'local' === n)
                      ) {
                        let t = e[r].getId(),
                          n = this.tempRemoveAnnotsUserId[t]
                        c.set('userId', n || o),
                          delete this.tempRemoveAnnotsUserId[t]
                      } else c.set('userId', o)
                    Object.entries(t).forEach(function ([e, t]) {
                      c.set(e, t)
                    })
                  }),
                    e.forEach(function (e) {
                      i.update(e)
                    })
                }, n)
              })
            }
            encodeAnnotationUpdate(e, t, n) {
              return s(this, void 0, void 0, function* () {
                this.context.currentUser.id
                const o = this.pdfViewer.getAnnotAuthorityManager(),
                  r = this.pdfViewer.getCurrentPDFDoc(),
                  i = yield r.exportAnnotsToJSON(e),
                  s = t.getMap('pageAnnotMaps')
                t.transact(function () {
                  i.forEach((e) => {
                    const t = e.page.toString()
                    let n = s.get(t)
                    n || ((n = new d.Map()), s.set(t, n))
                    let o = n.get(e.name + `__${t}`)
                    if (!o) return
                    let r = o.toJSON()
                    Object.entries(e).forEach(function ([t, n]) {
                      'userId' !== t &&
                        (('fileattachment' === e.type && 'raw' === t) ||
                          (r[t] !== n && o.set(t, n)))
                    }),
                      Object.keys(r).forEach(function (t) {
                        'userId' !== t && void 0 === e[t] && o.delete(t)
                      })
                  }),
                    e.forEach(function (e) {
                      o.update(e)
                    })
                }, n)
              })
            }
            encodeAsYDocTypes(e, t, n = 'local') {
              return s(this, void 0, void 0, function* () {
                const o = this.ydoc
                if (0 === e.length) return []
                const r = e
                t !== a.Event.annotationRemoved
                  ? t !== a.Event.annotationAdded
                    ? yield this.encodeAnnotationUpdate(r, this.ydoc, n)
                    : yield this.encodeAnnotationAdd(r, this.ydoc, n)
                  : o.transact(
                      () =>
                        r.map((e) => {
                          const t = o.getMap('pageAnnotMaps'),
                            r = e.getPage().getIndex().toString()
                          let i = t.get(r)
                          if (i) {
                            let t = e.getUniqueID() + `__${r}`
                            if ('local' === n) {
                              let n = i.get(t)
                              if (n) {
                                let t = n.toJSON()
                                this.tempRemoveAnnotsUserId[e.getId()] =
                                  t.userId
                              }
                            }
                            i.delete(t)
                          }
                        }),
                      n
                    )
              })
            }
            initYDoc() {
              v.LOGGER.debug('starting to init ydoc'), this.destroyYDoc()
              let e = new d.Doc()
              this.ydoc = e
            }
            initProviders(e) {
              return s(this, void 0, void 0, function* () {
                const t = this.ydoc
                try {
                  yield this.initIndexedDBProvider('collab$$' + e, this.ydoc)
                } catch (n) {
                  v.LOGGER.error(
                    'Failed to enable offline mode due to browser setup.'
                  )
                }
                this.initWebSocketProvider(t)
              })
            }
            initWebSocketProvider(e) {
              e.on('update', (e, t) => {
                'local' === t && this.syncUpdate(e)
              })
            }
            initIndexedDBProvider(e, t) {
              const n = new f.IndexeddbPersistence(e, t)
              return (
                (this.idbPersistencePromise = new Promise((e, t) => {
                  n.on('synced', function (t) {
                    v.LOGGER.debug(
                      'synced ydoc state with indexedDB persistence',
                      t.name
                    ),
                      e(t)
                  }),
                    n.on('error', function (e) {
                      t(e)
                    })
                })),
                this.idbPersistencePromise
              )
            }
            destroyYDoc() {
              var e
              null === (e = this.ydoc) || void 0 === e || e.destroy(),
                delete this.ydoc
            }
          }
        },
        1630: function (e, t, n) {
          var o =
              (this && this.__createBinding) ||
              (Object.create
                ? function (e, t, n, o) {
                    void 0 === o && (o = n)
                    var r = Object.getOwnPropertyDescriptor(t, n)
                    ;(r &&
                      !('get' in r
                        ? !t.__esModule
                        : r.writable || r.configurable)) ||
                      (r = {
                        enumerable: !0,
                        get: function () {
                          return t[n]
                        },
                      }),
                      Object.defineProperty(e, o, r)
                  }
                : function (e, t, n, o) {
                    void 0 === o && (o = n), (e[o] = t[n])
                  }),
            r =
              (this && this.__setModuleDefault) ||
              (Object.create
                ? function (e, t) {
                    Object.defineProperty(e, 'default', {
                      enumerable: !0,
                      value: t,
                    })
                  }
                : function (e, t) {
                    e.default = t
                  }),
            i =
              (this && this.__importStar) ||
              function (e) {
                if (e && e.__esModule) return e
                var t = {}
                if (null != e)
                  for (var n in e)
                    'default' !== n &&
                      Object.prototype.hasOwnProperty.call(e, n) &&
                      o(t, e, n)
                return r(t, e), t
              },
            s =
              (this && this.__awaiter) ||
              function (e, t, n, o) {
                return new (n || (n = Promise))(function (r, i) {
                  function s(e) {
                    try {
                      c(o.next(e))
                    } catch (t) {
                      i(t)
                    }
                  }
                  function a(e) {
                    try {
                      c(o.throw(e))
                    } catch (t) {
                      i(t)
                    }
                  }
                  function c(e) {
                    var t
                    e.done
                      ? r(e.value)
                      : ((t = e.value),
                        t instanceof n
                          ? t
                          : new n(function (e) {
                              e(t)
                            })).then(s, a)
                  }
                  c((o = o.apply(e, t || [])).next())
                })
              }
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.SdkCollabService = void 0)
          const a = n(5608),
            c = i(n(9703)),
            d = n(5285),
            l = n(9594)
          function u(e, t, n) {
            return s(this, void 0, void 0, function* () {
              if (e.inreplyto) {
                let o = yield n.getCurrentPDFDoc()
                const r = yield o.getPageByIndex(e.page),
                  i = (yield r.getAnnotsByIdArray([
                    e.inreplyto,
                  ]))[0].exportToJSON()
                t.push(i), i.inreplyto && (yield u(i, t, n))
              }
            })
          }
          function h(e, t) {
            return s(this, void 0, void 0, function* () {
              return e
            })
          }
          function f(e, t) {
            return s(this, void 0, void 0, function* () {
              if (!e || !e.length) return
              let n = e[0].page
              const o = yield t.getCurrentPDFDoc()
              let r = yield o.getPageByIndex(Number(n))
              if (!r) return
              let i = yield r.getAnnotsByIdArray(
                e.map(function (e) {
                  return e.name
                })
              )
              if (!i || !i.length) return
              let s = yield t.getAnnotAuthorityManager()
              i.forEach(function (e) {
                s.update(e)
              })
            })
          }
          t.SdkCollabService = class {
            constructor(e, t, n, o) {
              ;(this.sdkAnnotEventService = n),
                (this.mousePointerService = o),
                (this.onBroadcastCollabNotice = (e) => {
                  const { type: t, data: n } = e
                  if (this.isContinueProcessing(n))
                    switch (t) {
                      case a.DocumentAction.SYNC_YLOG:
                        this.applyYlog(n.ylog)
                        break
                      case a.DocumentAction.SYNC_YLOG_STEP_1:
                        l.LOGGER.debug('received sync-ylog-s1 from server', {
                          serverId: this.context.serverId,
                        }),
                          this.handleSyncStep1(n.ylog)
                        break
                      case a.DocumentAction.SYNC_YLOG_STEP_2:
                        l.LOGGER.debug(
                          `received sync-ylog-s2 from server, size: ${n.ylog.length}`,
                          { serverId: this.context.serverId }
                        ),
                          this.handleSyncStep2(n.ylog)
                        break
                      case a.DocumentAction.MOUSE_POINTER_SYNC:
                        this.mousePointerService.render({
                          userId: n.user_id,
                          sessionId: n.session_id,
                          state: n.state,
                        })
                    }
                }),
                (this.deleteAnnots = (e) =>
                  s(this, void 0, void 0, function* () {
                    const { annots: t, isDeleteLocal: n } = e
                    l.LOGGER.debug('start to delete annotations: ', t)
                    let o = yield this.pdfViewer.getCurrentPDFDoc()
                    for (const e of t) {
                      let t = e.annotId,
                        n = e.pageIndex
                      const r = this.pdfViewer.getAnnotRender(+e.pageIndex, t)
                      r && r.component.isActive && r.unActive()
                      const i = () => {
                        this.pdfViewer.customs.pushUndoStack = void 0
                      }
                      this.pdfViewer.customs.pushUndoStack = (e, t) => {
                        if ('REMOVEANNOT' == e) return !1
                      }
                      const s = yield o.getPageByIndex(n)
                      s &&
                        s.removeAnnotById(t).then((e) => {
                          i(),
                            this.sdkAnnotEventService.undoRedoManager &&
                              this.sdkAnnotEventService.undoRedoManager.removeByName(
                                t
                              )
                        })
                    }
                  })),
                (this.pdfViewer = e),
                (this.context = t),
                (this.annotList = []),
                (this.otherAnnotsList = []),
                (this.annotArr = []),
                (this.pendingList = []),
                (this.totalAnnotsCount =
                  this.annotList.length + this.otherAnnotsList.length),
                (this.ydoc = n.ydoc)
            }
            getAnnotUserId(e, t) {
              let n = this.sdkAnnotEventService.ydoc
              if (!n) return
              let o = n.get(t.toString())
              if (!o) return
              let r = o._length(e)
              return r ? r.toJSON().userId : void 0
            }
            resetCollaborationData() {
              ;(this.annotList = []), (this.otherAnnotsList = [])
            }
            setOwnerAnnotId(e) {
              this.otherAnnotsList.push(e)
            }
            uploadInitialAnnots() {
              return s(this, void 0, void 0, function* () {
                const e = yield this.pdfViewer.getCurrentPDFDoc()
                if (!e)
                  throw new Error(
                    'A PDF document need to be opened by PDFViewer first before creating collaboration.'
                  )
                const t = yield e.getAnnots(),
                  n = []
                t.forEach((e) => {
                  n.push(...e)
                }),
                  yield this.sdkAnnotEventService.addInitialAnnotations(n)
              })
            }
            isContinueProcessing(e) {
              return (
                !this.context.currentUser ||
                this.context.sessionId !== e.session_id ||
                this.context.currentUser.id != e.user_id
              )
            }
            fetchInitialAnnots(e) {
              return s(this, void 0, void 0, function* () {
                this.sendSyncStep1(e)
              })
            }
            sendSyncStep1(e) {
              return s(this, void 0, void 0, function* () {
                const t = this.sdkAnnotEventService.ydoc,
                  n = c.encodeStateVector(t)
                this.sdkAnnotEventService.syncUpdate(
                  n,
                  a.DocumentAction.SYNC_YLOG_STEP_1,
                  e
                )
              })
            }
            ydocToPDF(e) {
              return s(this, void 0, void 0, function* () {
                if (!e) return
                let t = e.getMap('pageAnnotMaps')
                const n = this.pdfViewer,
                  o = this.deleteAnnots
                t.observeDeep(function (e, t) {
                  return s(this, void 0, void 0, function* () {
                    l.LOGGER.debug(
                      'observed yevents:',
                      e,
                      'from origin:',
                      t.origin,
                      'server' === t.origin
                        ? { serverId: d.context.serverId }
                        : ''
                    ),
                      'local' !== t.origin &&
                        (yield (function (e, t) {
                          return s(this, void 0, void 0, function* () {
                            const t = yield n.getCurrentPDFDoc()
                            for (let r of e) {
                              let e = r.target,
                                i = r.path,
                                s = r.changes.keys
                              if (!i.length) {
                                let r = [],
                                  i = [],
                                  a = !1
                                if (
                                  (s.forEach(function (
                                    { action: t, oldValue: n },
                                    o
                                  ) {
                                    if ('add' === t) {
                                      const [t, n] = o.split('__')
                                      if (void 0 !== n) {
                                        if (!e.get(o).toJSON)
                                          return void l.LOGGER.debug(
                                            'no toJSON found for target by key',
                                            e,
                                            o
                                          )
                                        l.LOGGER.debug(e.get(o).toJSON()),
                                          r.push(e.get(o).toJSON())
                                      } else {
                                        if (!e.get(o).toJSON)
                                          return void l.LOGGER.debug(
                                            'no toJSON found for target by key',
                                            e,
                                            o
                                          )
                                        const t = e.get(o).toJSON()
                                        r = r.concat(Object.values(t))
                                      }
                                    } else if ('delete' === t) {
                                      const [e, t] = o.split('__')
                                      void 0 !== t &&
                                        i.push({
                                          annotId: e,
                                          pageIndex: Number(t),
                                        })
                                    } else
                                      'update' === t &&
                                        (l.LOGGER.debug(
                                          'path length is 0 and action is update, the target is',
                                          e
                                        ),
                                        (a = !0))
                                  }),
                                  a && e.toJSON)
                                ) {
                                  const t = e.toJSON()
                                  yield h(t), r.push(t)
                                }
                                l.LOGGER.debug(
                                  'path length = 0, start to import annots',
                                  r
                                ),
                                  yield t.importAnnotsFromJSON(r),
                                  yield f(r, n),
                                  i.length &&
                                    (yield o({ annots: i, isDeleteLocal: !0 }))
                              }
                              if (1 === i.length) {
                                const r = [],
                                  a = []
                                if (i[0].split('__')[1]) {
                                  if (!e.toJSON)
                                    return void l.LOGGER.debug(
                                      'path length is 1 and not toJSON found for target',
                                      e
                                    )
                                  let o = e.toJSON()
                                  yield h(o)
                                  let r = [o]
                                  o.inreplyto && (yield u(o, r, n)),
                                    yield t.importAnnotsFromJSON(r),
                                    yield f(r, n)
                                } else
                                  s.forEach(function (
                                    { action: t, oldValue: n },
                                    o
                                  ) {
                                    if ('add' === t || 'update' === t) {
                                      let t = e.get(o)
                                      t.toJSON
                                        ? r.push(t.toJSON())
                                        : l.LOGGER.debug(
                                            `${o} not found in `,
                                            e
                                          )
                                    } else if ('delete' === t) {
                                      const e = o.split('__')[0]
                                      a.push({
                                        annotId: e,
                                        pageIndex: ((s = i[0]), Number(s)),
                                      })
                                    }
                                    var s
                                  }),
                                    r.length &&
                                      (1 === r.length && (yield u(r[0], r, n)),
                                      l.LOGGER.debug(
                                        'path length = 1, start to import annots',
                                        r
                                      ),
                                      yield t.importAnnotsFromJSON(r),
                                      yield f(r, n)),
                                    a.length &&
                                      (yield o({
                                        annots: a,
                                        isDeleteLocal: !0,
                                      }))
                              }
                              if (2 === i.length) {
                                if (!e.toJSON)
                                  return void l.LOGGER.debug(
                                    'not toJSON found for target',
                                    e
                                  )
                                let o = e.toJSON()
                                yield h(o)
                                let r = [o]
                                o.inreplyto && (yield u(o, r, n)),
                                  l.LOGGER.debug(
                                    'path length = 2, start to import annots',
                                    r
                                  ),
                                  yield t.importAnnotsFromJSON(r),
                                  yield f(r, n)
                                const i = n.getAnnotRender(o.page, o.name),
                                  s =
                                    null === i || void 0 === i
                                      ? void 0
                                      : i.getComponent()
                                ;(null === s || void 0 === s
                                  ? void 0
                                  : s.isActive) &&
                                  'Note' === o.subject &&
                                  (yield i.unActive(), yield i.active())
                              }
                            }
                          })
                        })(e))
                  })
                })
              })
            }
            handleSyncStep1(e) {
              const t = this.sdkAnnotEventService.ydoc
              t &&
                this.sdkAnnotEventService.idbPersistencePromise
                  .then(() => {
                    const n = c.encodeStateAsUpdate(t, e)
                    this.sdkAnnotEventService.syncUpdate(
                      n,
                      a.DocumentAction.SYNC_YLOG_STEP_2,
                      this.context.currentDocId
                    )
                  })
                  .catch(() => {
                    const n = c.encodeStateAsUpdate(t, e)
                    this.sdkAnnotEventService.syncUpdate(
                      n,
                      a.DocumentAction.SYNC_YLOG_STEP_2,
                      this.context.currentDocId
                    )
                  })
            }
            handleSyncStep2(e) {
              this.applyYlog(e)
            }
            applyYlog(e) {
              l.LOGGER.debug('start to apply ylog update, size: ', e.length)
              const t = this.sdkAnnotEventService.ydoc
              this.pendingList.push(e),
                this.applyingTimeout ||
                  (this.applyingTimeout = setTimeout(() => {
                    this.applyingTimeout &&
                      (clearTimeout(this.applyingTimeout),
                      (this.applyingTimeout = null)),
                      c.transact(
                        t,
                        () => {
                          this.pendingList.forEach(function (e) {
                            c.applyUpdate(t, e, 'server')
                          })
                        },
                        'server',
                        !1
                      ),
                      (this.pendingList = [])
                  }, 300))
            }
            observeYDoc() {
              l.LOGGER.debug('setup ydoc and PDF binding'),
                this.ydocToPDF(this.sdkAnnotEventService.ydoc)
            }
          }
        },
        7306: function (e, t, n) {
          var o =
              (this && this.__createBinding) ||
              (Object.create
                ? function (e, t, n, o) {
                    void 0 === o && (o = n)
                    var r = Object.getOwnPropertyDescriptor(t, n)
                    ;(r &&
                      !('get' in r
                        ? !t.__esModule
                        : r.writable || r.configurable)) ||
                      (r = {
                        enumerable: !0,
                        get: function () {
                          return t[n]
                        },
                      }),
                      Object.defineProperty(e, o, r)
                  }
                : function (e, t, n, o) {
                    void 0 === o && (o = n), (e[o] = t[n])
                  }),
            r =
              (this && this.__setModuleDefault) ||
              (Object.create
                ? function (e, t) {
                    Object.defineProperty(e, 'default', {
                      enumerable: !0,
                      value: t,
                    })
                  }
                : function (e, t) {
                    e.default = t
                  }),
            i =
              (this && this.__importStar) ||
              function (e) {
                if (e && e.__esModule) return e
                var t = {}
                if (null != e)
                  for (var n in e)
                    'default' !== n &&
                      Object.prototype.hasOwnProperty.call(e, n) &&
                      o(t, e, n)
                return r(t, e), t
              },
            s =
              (this && this.__awaiter) ||
              function (e, t, n, o) {
                return new (n || (n = Promise))(function (r, i) {
                  function s(e) {
                    try {
                      c(o.next(e))
                    } catch (t) {
                      i(t)
                    }
                  }
                  function a(e) {
                    try {
                      c(o.throw(e))
                    } catch (t) {
                      i(t)
                    }
                  }
                  function c(e) {
                    var t
                    e.done
                      ? r(e.value)
                      : ((t = e.value),
                        t instanceof n
                          ? t
                          : new n(function (e) {
                              e(t)
                            })).then(s, a)
                  }
                  c((o = o.apply(e, t || [])).next())
                })
              }
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.SdkScreenSyncService = void 0)
          const a = n(7418),
            c = i(n(5741)),
            d = n(4255)
          t.SdkScreenSyncService = class {
            constructor(e, t) {
              ;(this.pdfViewer = e),
                (this.context = t),
                (this.syncScreenData = null),
                (this.leaderId = void 0),
                (this.updateScreenSyncData = (0,
                d.getScreenSyncInitialInfo)().defaultScreenSyncData),
                (this.getScrollData = (0, a.throttle)(
                  this.getScrollData.bind(this)
                ))
            }
            listenScreenSyncData() {
              var e
              return s(this, void 0, void 0, function* () {
                this.leaderId &&
                  this.leaderId ===
                    (null === (e = this.context.currentUser) || void 0 === e
                      ? void 0
                      : e.id) &&
                  (yield c.syncScreenData(
                    this.screenSyncId,
                    this.updateScreenSyncData
                  ))
              })
            }
            getPdfInfo() {
              return s(this, void 0, void 0, function* () {
                return yield this.pdfViewer.getPDFDocRender().getOffsetInfo()
              })
            }
            getScrollData() {
              return s(this, void 0, void 0, function* () {
                let e = this.pdfViewer.getScrollWrap().getScrollY(),
                  t = this.pdfViewer.getScrollWrap().getScrollX(),
                  n = yield this.getPdfInfo()
                ;(this.updateScreenSyncData.scrollPosition.x = t),
                  (this.updateScreenSyncData.scrollPosition.y = e),
                  (this.updateScreenSyncData.pdfInfo = n),
                  this.listenScreenSyncData()
              })
            }
            setZoomBySDK(e) {
              var t
              return s(this, void 0, void 0, function* () {
                let n = yield this.getPdfInfo()
                ;(this.updateScreenSyncData.zoom = e),
                  (this.updateScreenSyncData.pdfInfo = n),
                  this.leaderId &&
                    this.leaderId ===
                      (null === (t = this.context.currentUser) || void 0 === t
                        ? void 0
                        : t.id) &&
                    this.listenScreenSyncData()
              })
            }
            setViewModeBySDK(e) {
              var t
              return s(this, void 0, void 0, function* () {
                let n = yield this.getPdfInfo()
                ;(this.updateScreenSyncData.layoutMode = e.getName()),
                  (this.updateScreenSyncData.pdfInfo = n),
                  this.leaderId &&
                    this.leaderId ===
                      (null === (t = this.context.currentUser) || void 0 === t
                        ? void 0
                        : t.id) &&
                    this.listenScreenSyncData()
              })
            }
            addscreenSyncListener(e, t) {
              if ((this.getScrollData(), this.leaderId)) return
              this.pdfViewer.getScrollWrap().scrollHost
              ;(this.screenSyncId = e),
                (this.leaderId = t),
                (this.pdfviewerWrap =
                  this.pdfViewer.getScrollWrap().scrollHost),
                window.addEventListener('scroll', this.getScrollData, !0)
            }
            removeScreenSyncListener() {
              window.removeEventListener('scroll', this.getScrollData, !0),
                (this.leaderId = void 0)
            }
            leaveScreenSync() {
              this.syncScreenData = null
            }
            sync(e) {
              return s(this, void 0, void 0, function* () {
                const { screenSyncData: t, leader: n } = e
                let o = yield this.getPdfInfo()
                if (
                  ((null !== this.syncScreenData &&
                    (0, d.isObjectValueEqual)(
                      this.syncScreenData.scrollPosition,
                      t.scrollPosition
                    )) ||
                    this.handleScrollEvent(t, o.scale),
                  null === this.syncScreenData ||
                    this.syncScreenData.zoom !== t.zoom)
                ) {
                  const { top: e, left: n, index: o } = t.pdfInfo
                  this.pdfViewer.zoomTo(t.zoom, { x: n, y: e, pageIndex: o })
                }
                ;(null !== this.syncScreenData &&
                  this.syncScreenData.layoutMode === t.layoutMode) ||
                  this.pdfViewer.getViewModeManager().switchTo(t.layoutMode),
                  (this.syncScreenData = t)
              })
            }
            handleScrollEvent(e, t) {
              let n = Number(e.scrollPosition.y),
                o = Number(e.scrollPosition.x),
                r = t / e.pdfInfo.scale,
                i = Number(n * r),
                s = Number(o * r)
              this.pdfViewer.getScrollWrap().scrollTo(s, i)
            }
            setSyncRate(e) {
              this.getScrollData.setThreshold(e)
            }
          }
        },
        7857: (e, t, n) => {
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.WebSdkBinding = void 0)
          const o = n(923),
            r = n(1630),
            i = n(7306),
            s = n(5231)
          t.WebSdkBinding = class {
            constructor(e, t) {
              ;(this.sdkAnnotEventService = new o.SdkAnnotEventService(e, t)),
                (this.sdkScreenSyncService = new i.SdkScreenSyncService(e, t)),
                (this.mousePointerService = new s.MousePointerService(e, t)),
                (this.sdkCollabService = new r.SdkCollabService(
                  e,
                  t,
                  this.sdkAnnotEventService,
                  this.mousePointerService
                ))
            }
          }
        },
        8907: (e, t) => {
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.Event = void 0)
          let n = Object.assign(
            Object.assign(
              {},
              {
                jrLicenseSuccess: 'jr-license-success',
                srLicenseSuccess: 'sr-license-success',
                beforeOpenFile: 'before-open-file',
                openingFile: 'opening-file',
                beforeLoadPDFDoc: 'before-load-pdf-document',
                startConvert: 'start-convert',
                finishConvert: 'finish-convert',
                openFileSuccess: 'open-file-success',
                openFileFailed: 'open-file-failed',
                willCloseDocument: 'will-close-document',
                renderFileSuccess: 'render-file-success',
                renderFileFailed: 'render-file-error',
                beforeRenderPage: 'before-render-page',
                renderPageSuccess: 'render-page-success',
                beforeZoomTo: 'before-zoom-to',
                zoomToSuccess: 'zoom-to-success',
                zoomToFailed: 'zoom-to-failed',
                startChangeViewMode: 'start-change-view-mode',
                changeViewModeSuccess: 'change-view-mode-success',
                changeViewModeFailed: 'change-view-mode-failed',
                pagesLayoutRedrawBegin: 'pages-layout-redraw-begin',
                pageLayoutRedraw: 'page-layout-redraw',
                pagesLayoutRedrawEnd: 'pages-layout-redraw-end',
                copyTextSuccess: 'copy-text-success',
                copyTextFailed: 'copy-text-failed',
                tapPage: 'tap-page',
                tapAnnotation: 'tap-annotation',
                pressPage: 'press-page',
                pressAnnotation: 'press-annotation',
                pressText: 'press-text',
                rightClickPage: 'right-click-page',
                rightClickAnnotation: 'right-click-annotation',
                doubleTapPage: 'double-tap-page',
                doubleTapAnnotation: 'double-tap-annotation',
                activeAnnotationBefore: 'active-annotation-before',
                activeAnnotation: 'active-annotation',
                activeAnnotationAfter: 'active-annotation-after',
                panActiveAnnotation: 'pan-active-annotation',
                doubleTapActiveAnnotation: 'double-tap-active-annotation',
                contextMenuActiveAnnotation: 'contextmenu-action-annotation',
                unActiveAnnotation: 'unactive-annotation',
                updateActiveAnnotation: 'update-action-annotation',
                updateActionAnnotation: 'update-action-annotation',
                removeActiveAnnotationBefore: 'remove-action-annotation-before',
                removeActionAnnotationBefore: 'remove-action-annotation-before',
                removeActiveAnnotationSuccess:
                  'remove-action-annotation-success',
                removeActionAnnotationSuccess:
                  'remove-action-annotation-success',
                removeActiveAnnotationFailed: 'remove-action-annotation-failed',
                removeActionAnnotationFailed: 'remove-action-annotation-failed',
                switchStateHandler: 'switch-state-handler',
                deactiveStateHandler: 'deactive-state-handler',
                redactAnnotRendered: 'redact-annot-rendered',
                redactAnnotAllApplyed: 'applyed-all-redaction',
                redactAnnotApplyed: 'applyed-redaction',
                pageNumberChange: 'page-number-change',
                beforeDocumentRotation: 'before-document-rotation',
                afterDocumentRotation: 'after-document-rotation',
                snapModeChanged: 'snap-mode-changed',
                createPageAreaRenderer: 'create-page-area-renderer',
                destroyPageAreaRenderer: 'destroy-page-area-renderer',
                startUpdatePageAreaRenderer: 'start-update-page-area-renderer',
                createSnapshotArea: 'create-snapshot-area',
                updateSnapshotArea: 'update-snapshot-area',
                stabilizedSnapshotArea: 'stabilized-snapshot-area',
                switchPageAreaRenderer: 'switch-page-area-renderer',
                fitWidthResizeViewport: 'fit-width-resize-viewport',
                signatureFieldMouseLButtonDown: 'signature-field-Lbutton-down',
                signatureFieldMouseLButtonUp: 'signature-field-LButton-up',
                signatureFieldMouseEnter: 'signature-field-mouse-enter',
                signatureFieldMouseExit: 'signature-field-mouse-exit',
                visiblePagesRenderCompleted: 'completed-render-visible-pages',
                marqueeZoomIn: 'marquee-zoom-in',
                marqueeZoomOut: 'marquee-zoom-out',
                inkSignAdded: 'inkSign-added',
                inkSignDeleted: 'inkSign-deleted',
                pageMoved: 'page-moved',
                pageRemoved: 'page-removed',
                pageAdded: 'page-added',
                customDataAdd: 'custom-data-add',
                customDataImported: 'custom-data-imported',
                customDataRemoved: 'custom-data-removed',
                customDataUpdated: 'custom-data-updated',
                securityTypeChanged: 'security-type-changed',
                distanceAnnotCreationStart: 'distance-creation-start',
                updateDistanceAnnot: 'update-distance-annot',
                distanceAnnotCreationEnd: 'distance-creation-end',
                distanceAnnotCreationCancel: 'distance-creation-cancel',
                addEditImage: 'add-edit-image',
                InkImageSelected: 'ink-image-selected',
                checkTheSearch: 'check-the-search',
                activeElementChanged: 'active-element-changed',
                cancelCreatingDistance: 'cancel-creating-measurement',
                completeCreatingDistance: 'complete-creating-measurement',
                eraserSuccess: 'eraser-success',
                addAnnotSuccess: 'add-annot-success',
                cancelAddAnnot: 'cancel-add-annot',
                globalAnnotFlagChanged: 'global-annot-flag-changed',
                toolbarTabsClicked: 'toolbar-tabs-clicked',
                disableScroll: 'disable-scroll',
                enableScroll: 'enable-scroll',
                updateScrollableStatus: 'update-scrollable-status',
                selectText: 'select-text',
                changeEnableJS: 'change-enable-js',
                toggleEngineSr2JrSuccess: 'toggle-engine-sr-to-jr-success',
                iconInited: 'iconInited',
                iconAdded: 'iconAdded',
                iconRemoved: 'iconRemoved',
                annotationPermissionChanged: 'annotation-premission-changed',
                startScrollingPage: 'pdfui-start-scrolling-page',
                scrollingPage: 'pdfui-scrolling-page',
                endScrollingPage: 'pdfui-end-scrolling-page',
                designerAssistantStatusChanged:
                  'form-designer-assistant-status-changed',
                mouseEnter: 'mouse-enter',
                mouseLeave: 'mouse-leave',
                setFromFieldHighlight: 'set_form_field_highlight',
                AddFontMaps: 'set_font_map',
                thumbnailClicked: 'thumbnail-clicked',
                layerActionActived: 'layer-action-actived',
                redeModeShowSidebar: 'rede-mode-show-sidebar',
                gridToggle: 'grid-toggle',
                snapGridToggle: 'snap-grid-toggle',
                toggleCollaborationMode: 'toggleCollaborationMode',
                findReplaceDialogVisibleChange:
                  'find-replace-dialog-visible-change',
                showAllComments: 'show-all-comments',
                hideAllComments: 'hide-all-comments',
                focusInObject: 'focus-in-object',
                blurFromObject: 'blur-from-object',
              }
            ),
            {
              annotationUpdated: 'annotation-updated',
              annotationIDUpdated: 'annotation-id-updated',
              annotationAppearanceUpdated: 'annotation-appearance-updated',
              annotationReplyAdd: 'annotation-reply-add',
              annotationReviewStateAnnotAdd:
                'annotation-review-state-annot-add',
              annotationMarkedStateAnnotAdd:
                'annotation-marked-state-annot-add',
              annotationStatesCleared: 'annotation-states-cleared',
              annotationRemoved: 'annotation-removed',
              annotationMovedPosition: 'annotation-moved-position',
              annotationAdded: 'annotation-add',
              annotationAdd: 'annotation-add',
              moveAnnotsToPages: 'moveAnnotsToPages',
              annotationImported: 'annotation-imported',
              annotationImportedEx: 'annotation-imported-ex',
              annotationLoaded: 'annotation-loaded',
              actionUpdated: 'action-updated',
              actionAdd: 'action-add',
              actionRemove: 'action-remove',
              layerVisibleChange: 'layer-visible-change',
              layerRemoved: 'layer-removed',
              layerMerged: 'layer-merged',
              bookmarkAdded: 'bookmark-added',
              structureBookmarkAdded: 'structure-bookmark-added',
              bookmarkUpdated: 'bookmark-updated',
              bookmarkRemoved: 'bookmark-removed',
              stateAnnotNameUpdated: 'state-annot-name-updated',
              pageInfoChange: 'page-info-change',
              pageRotationChange: 'page-rotation-change',
              imageAdded: 'image-added',
              watermarkAdded: 'watermark-added',
              graphicsUpdated: 'graphics-updated',
              permissionChanged: 'permission-changed',
              drmEncryptSuccess: 'drm-encrypt-success',
              drmEncryptFailed: 'drm-encrypt-failed',
              pageMoved: 'page-moved',
              pageRemoved: 'page-removed',
              pageAdded: 'page-added',
              insertPages: 'import-pages',
              importPages: 'import-pages',
              documentAttachmentAdd: 'document-attachment-add',
              documentAttachmentModify: 'document-attachment-modify',
              documentAttachmentRemove: 'document-attachment-remove',
              applyRedaction: 'apply-redaction',
              removeReviewState: 'remove-review-state',
              removeMarkedState: 'remove-marked-state',
              formValueChanged: 'form-value-changed',
              metaDataChanged: 'meta-data-changed',
              docModified: 'doc-modified',
              flattened: 'flattened',
              headerFooterUpdated: 'headerFooterUpdated',
              headerFooterAdded: 'headerFooterAdded',
              COChange: 'COChange',
              pagesReversed: 'pages-reversed',
              pagesMoved: 'pages-moved',
              pagesRemoved: 'pages-removed',
              pagesRotated: 'pages-rotated',
              obtainsPageFromEngine: 'obtains-page-from-engine',
              pagesBoxChange: 'pages-box-changed',
              pagesLabelChange: 'pages-label-change',
              pagesLabelNeedUpdate: 'pages-label-need-change',
              pagesReplace: 'pages-replace',
              recognitionForm: 'recognition-form',
              removeEmbeddedPageThumbnail: 'remove-embedded-page-thumbnail',
              articleThreadAdded: 'article-thread-added',
              articleThreadUpdated: 'article-thread-updated',
              articleThreadRemoved: 'article-thread-removed',
              articleBeadAdded: 'article-bead-added',
              articleBeadRemoved: 'article-bead-removed',
              articleBeadUpdated: 'article-bead-updated',
              articleEnterReadMode: 'article-enter-read-mode',
              articleOutReadMode: 'article-out-read-mode',
              undoRedoStoreChange: 'undo-redo-store-change',
              fullscreenchange: 'fullscreenchange',
            }
          )
          t.Event = n
        },
        7918: function (e, t, n) {
          var o =
              (this && this.__createBinding) ||
              (Object.create
                ? function (e, t, n, o) {
                    void 0 === o && (o = n)
                    var r = Object.getOwnPropertyDescriptor(t, n)
                    ;(r &&
                      !('get' in r
                        ? !t.__esModule
                        : r.writable || r.configurable)) ||
                      (r = {
                        enumerable: !0,
                        get: function () {
                          return t[n]
                        },
                      }),
                      Object.defineProperty(e, o, r)
                  }
                : function (e, t, n, o) {
                    void 0 === o && (o = n), (e[o] = t[n])
                  }),
            r =
              (this && this.__setModuleDefault) ||
              (Object.create
                ? function (e, t) {
                    Object.defineProperty(e, 'default', {
                      enumerable: !0,
                      value: t,
                    })
                  }
                : function (e, t) {
                    e.default = t
                  }),
            i =
              (this && this.__importStar) ||
              function (e) {
                if (e && e.__esModule) return e
                var t = {}
                if (null != e)
                  for (var n in e)
                    'default' !== n &&
                      Object.prototype.hasOwnProperty.call(e, n) &&
                      o(t, e, n)
                return r(t, e), t
              }
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.encode = t.decode = t.encodeSubscribeDocMsg = void 0)
          const s = n(5608),
            a = i(n(4641)),
            c = i(n(1840))
          function d(e, t) {
            const n = a.createEncoder()
            return (
              a.writeUint8(n, e), a.writeVarUint8Array(n, t), a.toUint8Array(n)
            )
          }
          ;(t.encodeSubscribeDocMsg = function (e) {
            const t = {
              event: 'events',
              data: { type: s.MessageType.SUBSCRIBE_DOC, data: { docId: e } },
            }
            return JSON.stringify(t)
          }),
            (t.decode = function (e) {
              return e instanceof ArrayBuffer
                ? (function (e) {
                    const t = c.createDecoder(e),
                      n = c.readUint8(t),
                      o = c.readVarUint8Array(t)
                    if (0 === n)
                      return {
                        event: 'sync',
                        type: 'sync-ylog',
                        data: { ylog: o },
                      }
                    if (1 === n)
                      return {
                        event: 'sync',
                        type: 'sync-ylog-s1',
                        data: { type: 'sync-ylog-s1', ylog: o },
                      }
                    if (2 === n)
                      return {
                        event: 'sync',
                        type: 'sync-ylog-s2',
                        data: { type: 'sync-ylog-s2', ylog: o },
                      }
                    return null
                  })(new Uint8Array(e))
                : JSON.parse(e)
            }),
            (t.encode = function (e) {
              return e.type === s.DocumentAction.SYNC_YLOG
                ? d(0, e.data.ylog)
                : e.type === s.DocumentAction.SYNC_YLOG_STEP_1
                ? d(1, e.data.ylog)
                : e.type === s.DocumentAction.SYNC_YLOG_STEP_2
                ? d(2, e.data.ylog)
                : JSON.stringify(e)
            })
        },
        6526: function (e, t, n) {
          var o =
              (this && this.__createBinding) ||
              (Object.create
                ? function (e, t, n, o) {
                    void 0 === o && (o = n)
                    var r = Object.getOwnPropertyDescriptor(t, n)
                    ;(r &&
                      !('get' in r
                        ? !t.__esModule
                        : r.writable || r.configurable)) ||
                      (r = {
                        enumerable: !0,
                        get: function () {
                          return t[n]
                        },
                      }),
                      Object.defineProperty(e, o, r)
                  }
                : function (e, t, n, o) {
                    void 0 === o && (o = n), (e[o] = t[n])
                  }),
            r =
              (this && this.__setModuleDefault) ||
              (Object.create
                ? function (e, t) {
                    Object.defineProperty(e, 'default', {
                      enumerable: !0,
                      value: t,
                    })
                  }
                : function (e, t) {
                    e.default = t
                  }),
            i =
              (this && this.__importStar) ||
              function (e) {
                if (e && e.__esModule) return e
                var t = {}
                if (null != e)
                  for (var n in e)
                    'default' !== n &&
                      Object.prototype.hasOwnProperty.call(e, n) &&
                      o(t, e, n)
                return r(t, e), t
              },
            s =
              (this && this.__awaiter) ||
              function (e, t, n, o) {
                return new (n || (n = Promise))(function (r, i) {
                  function s(e) {
                    try {
                      c(o.next(e))
                    } catch (t) {
                      i(t)
                    }
                  }
                  function a(e) {
                    try {
                      c(o.throw(e))
                    } catch (t) {
                      i(t)
                    }
                  }
                  function c(e) {
                    var t
                    e.done
                      ? r(e.value)
                      : ((t = e.value),
                        t instanceof n
                          ? t
                          : new n(function (e) {
                              e(t)
                            })).then(s, a)
                  }
                  c((o = o.apply(e, t || [])).next())
                })
              },
            a =
              (this && this.__importDefault) ||
              function (e) {
                return e && e.__esModule ? e : { default: e }
              }
          Object.defineProperty(t, '__esModule', { value: !0 }),
            (t.stopCollaboration = t.startCollaboration = void 0)
          const c = n(5608),
            d = a(n(9397)),
            l = n(9648),
            u = n(5285),
            h = i(n(7918)),
            f = n(9594)
          let p,
            v,
            g = !1,
            y = !0
          function m(e) {
            e === c.NetworkConnectionEvent.NetworkConnectionDown &&
              y &&
              ((y = !1),
              u.context.listener && u.context.listener({ type: e, data: {} })),
              e !== c.NetworkConnectionEvent.NetworkConnectionUp ||
                y ||
                ((y = !0),
                u.context.listener && u.context.listener({ type: e, data: {} }))
          }
          function S(e, t) {
            return new Promise((n, o) => {
              const r = new d.default(e, void 0, {
                maxEnqueuedMessages: 0,
                debug: !1,
              })
              ;(r.binaryType = 'arraybuffer'),
                (r.onopen = () => {
                  f.LOGGER.debug(`websocket opened, ${e}`),
                    n(r),
                    (function (e) {
                      const t = { event: 'events', data: { type: 'heart' } }
                      v = setInterval(function () {
                        e.send(JSON.stringify(t))
                      }, 3e4)
                    })(r),
                    (function (e) {
                      e.onmessage = (e) => {
                        var t, n, o, r
                        let i = h.decode(e.data)
                        switch (i.type) {
                          case c.DocumentAction.DELETE_ANNOTS:
                          case c.DocumentAction.ADD_ANNOTS:
                          case c.DocumentAction.CHANGE_ANNOTS:
                          case c.DocumentAction.MOUSE_POINTER_SYNC:
                          case c.DocumentAction.SYNC_YLOG:
                          case c.DocumentAction.SYNC_YLOG_STEP_1:
                          case c.DocumentAction.SYNC_YLOG_STEP_2:
                            null === (t = u.context.webSdkBinding) ||
                              void 0 === t ||
                              t.sdkCollabService.onBroadcastCollabNotice(i)
                            break
                          case 'doc-subscribed':
                            null === (n = u.context.webSdkBinding) ||
                              void 0 === n ||
                              n.sdkCollabService.onBroadcastCollabNotice(i),
                              null === (o = u.context.webSdkBinding) ||
                                void 0 === o ||
                                o.mousePointerService.renderInitialMousePointers(
                                  i.data.mousePointerStates
                                ),
                              f.LOGGER.debug(
                                `user: ${i.data.id} subscribed to collaboration: ${i.data.docId} on server: ${i.data.serverId}`
                              ),
                              (u.context.serverId = i.data.serverId)
                            break
                          case 'heart-reply':
                          case 'doc-event-reply':
                            break
                          case c.DocumentAction.MEMBER_ONLINE:
                          case c.DocumentAction.MEMBER_OFFLINE:
                          case c.DocumentAction.DELETE_SHARE:
                          case c.DocumentAction.EDIT_MEMBERS:
                          case c.DocumentAction.DELETE_MEMBERS:
                          case l.ScreenSyncEvent.CREATED:
                          case l.ScreenSyncEvent.STOPPED:
                          case l.ScreenSyncEvent.MEMBER_JOINED:
                          case l.ScreenSyncEvent.MEMBER_LEAVE:
                          case l.ScreenSyncEvent.SCREENSYNC_DATA:
                            const e = i
                            e.type === c.DocumentAction.MEMBER_OFFLINE &&
                              (null === (r = u.context.webSdkBinding) ||
                                void 0 === r ||
                                r.mousePointerService.onMemberOffline(e.data)),
                              u.context.listener && u.context.listener(e)
                        }
                      }
                    })(r),
                    m(c.NetworkConnectionEvent.NetworkConnectionUp),
                    f.LOGGER.debug(`try subscribe to collaboration: ${t} `),
                    r.send(h.encodeSubscribeDocMsg(t)),
                    t &&
                      (f.LOGGER.debug(
                        'sync collaboration ydoc states after ws connect'
                      ),
                      setTimeout(() => {
                        var e
                        null === (e = u.context.webSdkBinding) ||
                          void 0 === e ||
                          e.sdkCollabService.sendSyncStep1(t)
                      }, 300))
                }),
                (r.onerror = (e) => {
                  f.LOGGER.error('websocket error', e),
                    m(c.NetworkConnectionEvent.NetworkConnectionDown),
                    o(e)
                })
            })
          }
          window.addEventListener('offline', (e) => {
            f.LOGGER.info('client network offline'),
              m(c.NetworkConnectionEvent.NetworkConnectionDown),
              (g = !0)
          }),
            window.addEventListener('online', (e) => {
              f.LOGGER.info('client network online'),
                g && (null === p || void 0 === p || p.reconnect()),
                (g = !1)
            }),
            (t.startCollaboration = function (e, t) {
              var n
              return s(this, void 0, void 0, function* () {
                const o =
                    null === (n = t.currentUser) || void 0 === n
                      ? void 0
                      : n.id,
                  r = t.sessionId
                let i = `${t.transport.websocketURL}?uid=${o}&sn=foxit&sessionId=${r}`
                try {
                  return (p = yield S(i, e)), p
                } catch (s) {
                  return null
                }
              })
            }),
            (t.stopCollaboration = function (e) {
              var t, n, o, r
              return s(this, void 0, void 0, function* () {
                const i = {
                  event: 'events',
                  data: {
                    type: c.MessageType.UNSUBSCRIBE_DOC,
                    data: { docId: e },
                  },
                }
                p.send(JSON.stringify(i)),
                  null === (t = u.context.webSdkBinding) ||
                    void 0 === t ||
                    t.sdkAnnotEventService.removeAnnotationListener(),
                  null === (n = u.context.webSdkBinding) ||
                    void 0 === n ||
                    n.sdkAnnotEventService.destroyYDoc(),
                  null === (o = u.context.webSdkBinding) ||
                    void 0 === o ||
                    o.mousePointerService.stop(),
                  v && clearInterval(v),
                  p.close(),
                  null === (r = u.context.webSdkBinding) ||
                    void 0 === r ||
                    r.sdkCollabService.resetCollaborationData(),
                  u.context.webSdkBinding.sdkScreenSyncService.removeScreenSyncListener()
              })
            })
        },
        3300: (e) => {
          e.exports = t
        },
        7430: (t) => {
          t.exports = e
        },
        9397: (e) => {
          e.exports = o
        },
        9703: (e) => {
          e.exports = n
        },
        9722: (e, t) => {
          const n = (e) => e[e.length - 1],
            o = () => [],
            r = (e) => e.slice(),
            i = (e, t) => {
              for (let n = 0; n < t.length; n++) e.push(t[n])
            },
            s = Array.from,
            a = (e, t) => e.every(t),
            c = (e, t) => e.some(t),
            d = (e, t) => e.length === t.length && a(e, (e, n) => e === t[n]),
            l = (e) => e.reduce((e, t) => e.concat(t), []),
            u = Array.isArray
          var h = Object.freeze({
            __proto__: null,
            last: n,
            create: o,
            copy: r,
            appendTo: i,
            from: s,
            every: a,
            some: c,
            equalFlat: d,
            flatten: l,
            isArray: u,
          })
          ;(t.appendTo = i),
            (t.array = h),
            (t.copy = r),
            (t.create = o),
            (t.equalFlat = d),
            (t.every = a),
            (t.flatten = l),
            (t.from = s),
            (t.isArray = u),
            (t.last = n),
            (t.some = c)
        },
        409: (e, t) => {
          const n = 1 << 17,
            o = 1 << 18,
            r = 1 << 19,
            i = 1 << 20,
            s = 1 << 21,
            a = 1 << 22,
            c = 1 << 23,
            d = 1 << 24,
            l = 1 << 25,
            u = 1 << 26,
            h = 1 << 27,
            f = 1 << 28,
            p = 1 << 29,
            v = 1 << 30,
            g = 1 << 31,
            y = 131071,
            m = 262143,
            S = 524287,
            b = 1048575,
            E = 2097151,
            _ = 4194303,
            w = 8388607,
            I = d - 1,
            A = l - 1,
            D = u - 1,
            O = h - 1,
            P = f - 1,
            C = p - 1,
            T = v - 1,
            R = 2147483647,
            B = 4294967295
          var M = Object.freeze({
            __proto__: null,
            BIT1: 1,
            BIT2: 2,
            BIT3: 4,
            BIT4: 8,
            BIT5: 16,
            BIT6: 32,
            BIT7: 64,
            BIT8: 128,
            BIT9: 256,
            BIT10: 512,
            BIT11: 1024,
            BIT12: 2048,
            BIT13: 4096,
            BIT14: 8192,
            BIT15: 16384,
            BIT16: 32768,
            BIT17: 65536,
            BIT18: n,
            BIT19: o,
            BIT20: r,
            BIT21: i,
            BIT22: s,
            BIT23: a,
            BIT24: c,
            BIT25: d,
            BIT26: l,
            BIT27: u,
            BIT28: h,
            BIT29: f,
            BIT30: p,
            BIT31: v,
            BIT32: g,
            BITS0: 0,
            BITS1: 1,
            BITS2: 3,
            BITS3: 7,
            BITS4: 15,
            BITS5: 31,
            BITS6: 63,
            BITS7: 127,
            BITS8: 255,
            BITS9: 511,
            BITS10: 1023,
            BITS11: 2047,
            BITS12: 4095,
            BITS13: 8191,
            BITS14: 16383,
            BITS15: 32767,
            BITS16: 65535,
            BITS17: y,
            BITS18: m,
            BITS19: S,
            BITS20: b,
            BITS21: E,
            BITS22: _,
            BITS23: w,
            BITS24: I,
            BITS25: A,
            BITS26: D,
            BITS27: O,
            BITS28: P,
            BITS29: C,
            BITS30: T,
            BITS31: R,
            BITS32: B,
          })
          ;(t.BIT1 = 1),
            (t.BIT10 = 512),
            (t.BIT11 = 1024),
            (t.BIT12 = 2048),
            (t.BIT13 = 4096),
            (t.BIT14 = 8192),
            (t.BIT15 = 16384),
            (t.BIT16 = 32768),
            (t.BIT17 = 65536),
            (t.BIT18 = n),
            (t.BIT19 = o),
            (t.BIT2 = 2),
            (t.BIT20 = r),
            (t.BIT21 = i),
            (t.BIT22 = s),
            (t.BIT23 = a),
            (t.BIT24 = c),
            (t.BIT25 = d),
            (t.BIT26 = l),
            (t.BIT27 = u),
            (t.BIT28 = h),
            (t.BIT29 = f),
            (t.BIT3 = 4),
            (t.BIT30 = p),
            (t.BIT31 = v),
            (t.BIT32 = g),
            (t.BIT4 = 8),
            (t.BIT5 = 16),
            (t.BIT6 = 32),
            (t.BIT7 = 64),
            (t.BIT8 = 128),
            (t.BIT9 = 256),
            (t.BITS0 = 0),
            (t.BITS1 = 1),
            (t.BITS10 = 1023),
            (t.BITS11 = 2047),
            (t.BITS12 = 4095),
            (t.BITS13 = 8191),
            (t.BITS14 = 16383),
            (t.BITS15 = 32767),
            (t.BITS16 = 65535),
            (t.BITS17 = y),
            (t.BITS18 = m),
            (t.BITS19 = S),
            (t.BITS2 = 3),
            (t.BITS20 = b),
            (t.BITS21 = E),
            (t.BITS22 = _),
            (t.BITS23 = w),
            (t.BITS24 = I),
            (t.BITS25 = A),
            (t.BITS26 = D),
            (t.BITS27 = O),
            (t.BITS28 = P),
            (t.BITS29 = C),
            (t.BITS3 = 7),
            (t.BITS30 = T),
            (t.BITS31 = R),
            (t.BITS32 = B),
            (t.BITS4 = 15),
            (t.BITS5 = 31),
            (t.BITS6 = 63),
            (t.BITS7 = 127),
            (t.BITS8 = 255),
            (t.BITS9 = 511),
            (t.binary = M)
        },
        6797: (e, t, n) => {
          var o = n(8720),
            r = n(4178),
            i = n(409),
            s = n(7039),
            a = n(2346),
            c = n(2203)
          class d {
            constructor() {
              ;(this.cpos = 0),
                (this.cbuf = new Uint8Array(100)),
                (this.bufs = [])
            }
          }
          const l = () => new d(),
            u = (e) => {
              let t = e.cpos
              for (let n = 0; n < e.bufs.length; n++) t += e.bufs[n].length
              return t
            },
            h = (e) => {
              const t = new Uint8Array(u(e))
              let n = 0
              for (let o = 0; o < e.bufs.length; o++) {
                const r = e.bufs[o]
                t.set(r, n), (n += r.length)
              }
              return t.set(xe(e.cbuf.buffer, 0, e.cpos), n), t
            },
            f = (e, t) => {
              const n = e.cbuf.length
              n - e.cpos < t &&
                (e.bufs.push(xe(e.cbuf.buffer, 0, e.cpos)),
                (e.cbuf = new Uint8Array(2 * s.max(n, t))),
                (e.cpos = 0))
            },
            p = (e, t) => {
              const n = e.cbuf.length
              e.cpos === n &&
                (e.bufs.push(e.cbuf),
                (e.cbuf = new Uint8Array(2 * n)),
                (e.cpos = 0)),
                (e.cbuf[e.cpos++] = t)
            },
            v = (e, t, n) => {
              let o = null
              for (let r = 0; r < e.bufs.length && null === o; r++) {
                const n = e.bufs[r]
                t < n.length ? (o = n) : (t -= n.length)
              }
              null === o && (o = e.cbuf), (o[t] = n)
            },
            g = p,
            y = v,
            m = (e, t) => {
              p(e, t & i.BITS8), p(e, (t >>> 8) & i.BITS8)
            },
            S = (e, t, n) => {
              v(e, t, n & i.BITS8), v(e, t + 1, (n >>> 8) & i.BITS8)
            },
            b = (e, t) => {
              for (let n = 0; n < 4; n++) p(e, t & i.BITS8), (t >>>= 8)
            },
            E = (e, t) => {
              for (let n = 3; n >= 0; n--) p(e, (t >>> (8 * n)) & i.BITS8)
            },
            _ = (e, t, n) => {
              for (let o = 0; o < 4; o++) v(e, t + o, n & i.BITS8), (n >>>= 8)
            },
            w = (e, t) => {
              for (; t > i.BITS7; )
                p(e, i.BIT8 | (i.BITS7 & t)), (t = s.floor(t / 128))
              p(e, i.BITS7 & t)
            },
            I = (e, t) => {
              const n = s.isNegativeZero(t)
              for (
                n && (t = -t),
                  p(
                    e,
                    (t > i.BITS6 ? i.BIT8 : 0) |
                      (n ? i.BIT7 : 0) |
                      (i.BITS6 & t)
                  ),
                  t = s.floor(t / 64);
                t > 0;

              )
                p(e, (t > i.BITS7 ? i.BIT8 : 0) | (i.BITS7 & t)),
                  (t = s.floor(t / 128))
            },
            A = new Uint8Array(3e4),
            D = A.length / 3,
            O = (e, t) => {
              if (t.length < D) {
                const n = o.utf8TextEncoder.encodeInto(t, A).written || 0
                w(e, n)
                for (let t = 0; t < n; t++) p(e, A[t])
              } else B(e, o.encodeUtf8(t))
            },
            P = (e, t) => {
              const n = unescape(encodeURIComponent(t)),
                o = n.length
              w(e, o)
              for (let r = 0; r < o; r++) p(e, n.codePointAt(r))
            },
            C = o.utf8TextEncoder && o.utf8TextEncoder.encodeInto ? O : P,
            T = (e, t) => R(e, h(t)),
            R = (e, t) => {
              const n = e.cbuf.length,
                o = e.cpos,
                r = s.min(n - o, t.length),
                i = t.length - r
              e.cbuf.set(t.subarray(0, r), o),
                (e.cpos += r),
                i > 0 &&
                  (e.bufs.push(e.cbuf),
                  (e.cbuf = new Uint8Array(s.max(2 * n, i))),
                  e.cbuf.set(t.subarray(r)),
                  (e.cpos = i))
            },
            B = (e, t) => {
              w(e, t.byteLength), R(e, t)
            },
            M = (e, t) => {
              f(e, t)
              const n = new DataView(e.cbuf.buffer, e.cpos, t)
              return (e.cpos += t), n
            },
            L = (e, t) => M(e, 4).setFloat32(0, t, !1),
            N = (e, t) => M(e, 8).setFloat64(0, t, !1),
            U = (e, t) => M(e, 8).setBigInt64(0, t, !1),
            x = (e, t) => M(e, 8).setBigUint64(0, t, !1),
            k = new DataView(new ArrayBuffer(4)),
            j = (e, t) => {
              switch (typeof t) {
                case 'string':
                  p(e, 119), C(e, t)
                  break
                case 'number':
                  a.isInteger(t) && s.abs(t) <= i.BITS31
                    ? (p(e, 125), I(e, t))
                    : ((n = t),
                      k.setFloat32(0, n),
                      k.getFloat32(0) === n
                        ? (p(e, 124), L(e, t))
                        : (p(e, 123), N(e, t)))
                  break
                case 'bigint':
                  p(e, 122), U(e, t)
                  break
                case 'object':
                  if (null === t) p(e, 126)
                  else if (t instanceof Array) {
                    p(e, 117), w(e, t.length)
                    for (let n = 0; n < t.length; n++) j(e, t[n])
                  } else if (t instanceof Uint8Array) p(e, 116), B(e, t)
                  else {
                    p(e, 118)
                    const n = Object.keys(t)
                    w(e, n.length)
                    for (let o = 0; o < n.length; o++) {
                      const r = n[o]
                      C(e, r), j(e, t[r])
                    }
                  }
                  break
                case 'boolean':
                  p(e, t ? 120 : 121)
                  break
                default:
                  p(e, 127)
              }
              var n
            }
          class V extends d {
            constructor(e) {
              super(), (this.w = e), (this.s = null), (this.count = 0)
            }
            write(e) {
              this.s === e
                ? this.count++
                : (this.count > 0 && w(this, this.count - 1),
                  (this.count = 1),
                  this.w(this, e),
                  (this.s = e))
            }
          }
          class F extends d {
            constructor(e) {
              super(), (this.s = e)
            }
            write(e) {
              I(this, e - this.s), (this.s = e)
            }
          }
          class G extends d {
            constructor(e) {
              super(), (this.s = e), (this.count = 0)
            }
            write(e) {
              this.s === e && this.count > 0
                ? this.count++
                : (this.count > 0 && w(this, this.count - 1),
                  (this.count = 1),
                  I(this, e - this.s),
                  (this.s = e))
            }
          }
          const q = (e) => {
            e.count > 0 &&
              (I(e.encoder, 1 === e.count ? e.s : -e.s),
              e.count > 1 && w(e.encoder, e.count - 2))
          }
          class Y {
            constructor() {
              ;(this.encoder = new d()), (this.s = 0), (this.count = 0)
            }
            write(e) {
              this.s === e
                ? this.count++
                : (q(this), (this.count = 1), (this.s = e))
            }
            toUint8Array() {
              return q(this), h(this.encoder)
            }
          }
          class $ {
            constructor() {
              ;(this.encoder = new d()), (this.s = 0), (this.count = 0)
            }
            write(e) {
              this.s + this.count === e
                ? this.count++
                : (q(this), (this.count = 1), (this.s = e))
            }
            toUint8Array() {
              return q(this), h(this.encoder)
            }
          }
          const z = (e) => {
            if (e.count > 0) {
              const t = 2 * e.diff + (1 === e.count ? 0 : 1)
              I(e.encoder, t), e.count > 1 && w(e.encoder, e.count - 2)
            }
          }
          class W {
            constructor() {
              ;(this.encoder = new d()),
                (this.s = 0),
                (this.count = 0),
                (this.diff = 0)
            }
            write(e) {
              this.diff === e - this.s
                ? ((this.s = e), this.count++)
                : (z(this),
                  (this.count = 1),
                  (this.diff = e - this.s),
                  (this.s = e))
            }
            toUint8Array() {
              return z(this), h(this.encoder)
            }
          }
          class J {
            constructor() {
              ;(this.sarr = []), (this.s = ''), (this.lensE = new Y())
            }
            write(e) {
              ;(this.s += e),
                this.s.length > 19 && (this.sarr.push(this.s), (this.s = '')),
                this.lensE.write(e.length)
            }
            toUint8Array() {
              const e = new d()
              return (
                this.sarr.push(this.s),
                (this.s = ''),
                C(e, this.sarr.join('')),
                R(e, this.lensE.toUint8Array()),
                h(e)
              )
            }
          }
          var K = Object.freeze({
            __proto__: null,
            Encoder: d,
            createEncoder: l,
            length: u,
            toUint8Array: h,
            verifyLen: f,
            write: p,
            set: v,
            writeUint8: g,
            setUint8: y,
            writeUint16: m,
            setUint16: S,
            writeUint32: b,
            writeUint32BigEndian: E,
            setUint32: _,
            writeVarUint: w,
            writeVarInt: I,
            _writeVarStringNative: O,
            _writeVarStringPolyfill: P,
            writeVarString: C,
            writeBinaryEncoder: T,
            writeUint8Array: R,
            writeVarUint8Array: B,
            writeOnDataView: M,
            writeFloat32: L,
            writeFloat64: N,
            writeBigInt64: U,
            writeBigUint64: x,
            writeAny: j,
            RleEncoder: V,
            IntDiffEncoder: F,
            RleIntDiffEncoder: G,
            UintOptRleEncoder: Y,
            IncUintOptRleEncoder: $,
            IntDiffOptRleEncoder: W,
            StringEncoder: J,
          })
          const Z = c.create('Unexpected end of array'),
            H = c.create('Integer out of Range')
          class X {
            constructor(e) {
              ;(this.arr = e), (this.pos = 0)
            }
          }
          const Q = (e) => new X(e),
            ee = (e) => e.pos !== e.arr.length,
            te = (e, t = e.pos) => {
              const n = Q(e.arr)
              return (n.pos = t), n
            },
            ne = (e, t) => {
              const n = xe(e.arr.buffer, e.pos + e.arr.byteOffset, t)
              return (e.pos += t), n
            },
            oe = (e) => ne(e, fe(e)),
            re = (e) => ne(e, e.arr.length - e.pos),
            ie = (e) => e.pos++,
            se = (e) => e.arr[e.pos++],
            ae = (e) => {
              const t = e.arr[e.pos] + (e.arr[e.pos + 1] << 8)
              return (e.pos += 2), t
            },
            ce = (e) => {
              const t =
                (e.arr[e.pos] +
                  (e.arr[e.pos + 1] << 8) +
                  (e.arr[e.pos + 2] << 16) +
                  (e.arr[e.pos + 3] << 24)) >>>
                0
              return (e.pos += 4), t
            },
            de = (e) => {
              const t =
                (e.arr[e.pos + 3] +
                  (e.arr[e.pos + 2] << 8) +
                  (e.arr[e.pos + 1] << 16) +
                  (e.arr[e.pos] << 24)) >>>
                0
              return (e.pos += 4), t
            },
            le = (e) => e.arr[e.pos],
            ue = (e) => e.arr[e.pos] + (e.arr[e.pos + 1] << 8),
            he = (e) =>
              (e.arr[e.pos] +
                (e.arr[e.pos + 1] << 8) +
                (e.arr[e.pos + 2] << 16) +
                (e.arr[e.pos + 3] << 24)) >>>
              0,
            fe = (e) => {
              let t = 0,
                n = 1
              const o = e.arr.length
              for (; e.pos < o; ) {
                const o = e.arr[e.pos++]
                if (((t += (o & i.BITS7) * n), (n *= 128), o < i.BIT8)) return t
                if (t > a.MAX_SAFE_INTEGER) throw H
              }
              throw Z
            },
            pe = (e) => {
              let t = e.arr[e.pos++],
                n = t & i.BITS6,
                o = 64
              const r = (t & i.BIT7) > 0 ? -1 : 1
              if (0 === (t & i.BIT8)) return r * n
              const s = e.arr.length
              for (; e.pos < s; ) {
                if (
                  ((t = e.arr[e.pos++]),
                  (n += (t & i.BITS7) * o),
                  (o *= 128),
                  t < i.BIT8)
                )
                  return r * n
                if (n > a.MAX_SAFE_INTEGER) throw H
              }
              throw Z
            },
            ve = (e) => {
              const t = e.pos,
                n = fe(e)
              return (e.pos = t), n
            },
            ge = (e) => {
              const t = e.pos,
                n = pe(e)
              return (e.pos = t), n
            },
            ye = (e) => {
              let t = fe(e)
              if (0 === t) return ''
              {
                let n = String.fromCodePoint(se(e))
                if (--t < 100) for (; t--; ) n += String.fromCodePoint(se(e))
                else
                  for (; t > 0; ) {
                    const o = t < 1e4 ? t : 1e4,
                      r = e.arr.subarray(e.pos, e.pos + o)
                    ;(e.pos += o),
                      (n += String.fromCodePoint.apply(null, r)),
                      (t -= o)
                  }
                return decodeURIComponent(escape(n))
              }
            },
            me = (e) => o.utf8TextDecoder.decode(oe(e)),
            Se = o.utf8TextDecoder ? me : ye,
            be = (e) => {
              const t = e.pos,
                n = Se(e)
              return (e.pos = t), n
            },
            Ee = (e, t) => {
              const n = new DataView(e.arr.buffer, e.arr.byteOffset + e.pos, t)
              return (e.pos += t), n
            },
            _e = (e) => Ee(e, 4).getFloat32(0, !1),
            we = (e) => Ee(e, 8).getFloat64(0, !1),
            Ie = (e) => Ee(e, 8).getBigInt64(0, !1),
            Ae = (e) => Ee(e, 8).getBigUint64(0, !1),
            De = [
              (e) => {},
              (e) => null,
              pe,
              _e,
              we,
              Ie,
              (e) => !1,
              (e) => !0,
              Se,
              (e) => {
                const t = fe(e),
                  n = {}
                for (let o = 0; o < t; o++) {
                  n[Se(e)] = Oe(e)
                }
                return n
              },
              (e) => {
                const t = fe(e),
                  n = []
                for (let o = 0; o < t; o++) n.push(Oe(e))
                return n
              },
              oe,
            ],
            Oe = (e) => De[127 - se(e)](e)
          class Pe extends X {
            constructor(e, t) {
              super(e), (this.reader = t), (this.s = null), (this.count = 0)
            }
            read() {
              return (
                0 === this.count &&
                  ((this.s = this.reader(this)),
                  ee(this) ? (this.count = fe(this) + 1) : (this.count = -1)),
                this.count--,
                this.s
              )
            }
          }
          class Ce extends X {
            constructor(e, t) {
              super(e), (this.s = t)
            }
            read() {
              return (this.s += pe(this)), this.s
            }
          }
          class Te extends X {
            constructor(e, t) {
              super(e), (this.s = t), (this.count = 0)
            }
            read() {
              return (
                0 === this.count &&
                  ((this.s += pe(this)),
                  ee(this) ? (this.count = fe(this) + 1) : (this.count = -1)),
                this.count--,
                this.s
              )
            }
          }
          class Re extends X {
            constructor(e) {
              super(e), (this.s = 0), (this.count = 0)
            }
            read() {
              if (0 === this.count) {
                this.s = pe(this)
                const e = s.isNegativeZero(this.s)
                ;(this.count = 1),
                  e && ((this.s = -this.s), (this.count = fe(this) + 2))
              }
              return this.count--, this.s
            }
          }
          class Be extends X {
            constructor(e) {
              super(e), (this.s = 0), (this.count = 0)
            }
            read() {
              if (0 === this.count) {
                this.s = pe(this)
                const e = s.isNegativeZero(this.s)
                ;(this.count = 1),
                  e && ((this.s = -this.s), (this.count = fe(this) + 2))
              }
              return this.count--, this.s++
            }
          }
          class Me extends X {
            constructor(e) {
              super(e), (this.s = 0), (this.count = 0), (this.diff = 0)
            }
            read() {
              if (0 === this.count) {
                const e = pe(this),
                  t = 1 & e
                ;(this.diff = s.floor(e / 2)),
                  (this.count = 1),
                  t && (this.count = fe(this) + 2)
              }
              return (this.s += this.diff), this.count--, this.s
            }
          }
          class Le {
            constructor(e) {
              ;(this.decoder = new Re(e)),
                (this.str = Se(this.decoder)),
                (this.spos = 0)
            }
            read() {
              const e = this.spos + this.decoder.read(),
                t = this.str.slice(this.spos, e)
              return (this.spos = e), t
            }
          }
          var Ne = Object.freeze({
            __proto__: null,
            Decoder: X,
            createDecoder: Q,
            hasContent: ee,
            clone: te,
            readUint8Array: ne,
            readVarUint8Array: oe,
            readTailAsUint8Array: re,
            skip8: ie,
            readUint8: se,
            readUint16: ae,
            readUint32: ce,
            readUint32BigEndian: de,
            peekUint8: le,
            peekUint16: ue,
            peekUint32: he,
            readVarUint: fe,
            readVarInt: pe,
            peekVarUint: ve,
            peekVarInt: ge,
            _readVarStringPolyfill: ye,
            _readVarStringNative: me,
            readVarString: Se,
            peekVarString: be,
            readFromDataView: Ee,
            readFloat32: _e,
            readFloat64: we,
            readBigInt64: Ie,
            readBigUint64: Ae,
            readAny: Oe,
            RleDecoder: Pe,
            IntDiffDecoder: Ce,
            RleIntDiffDecoder: Te,
            UintOptRleDecoder: Re,
            IncUintOptRleDecoder: Be,
            IntDiffOptRleDecoder: Me,
            StringDecoder: Le,
          })
          const Ue = (e) => new Uint8Array(e),
            xe = (e, t, n) => new Uint8Array(e, t, n),
            ke = (e) => new Uint8Array(e),
            je = r.isBrowser
              ? (e) => {
                  let t = ''
                  for (let n = 0; n < e.byteLength; n++)
                    t += o.fromCharCode(e[n])
                  return btoa(t)
                }
              : (e) =>
                  Buffer.from(e.buffer, e.byteOffset, e.byteLength).toString(
                    'base64'
                  ),
            Ve = r.isBrowser
              ? (e) => {
                  const t = atob(e),
                    n = Ue(t.length)
                  for (let o = 0; o < t.length; o++) n[o] = t.charCodeAt(o)
                  return n
                }
              : (e) => {
                  const t = Buffer.from(e, 'base64')
                  return new Uint8Array(t.buffer, t.byteOffset, t.byteLength)
                },
            Fe = (e) => {
              const t = Ue(e.byteLength)
              return t.set(e), t
            },
            Ge = (e) => {
              const t = l()
              return j(t, e), h(t)
            },
            qe = (e) => Oe(Q(e))
          var Ye = Object.freeze({
            __proto__: null,
            createUint8ArrayFromLen: Ue,
            createUint8ArrayViewFromArrayBuffer: xe,
            createUint8ArrayFromArrayBuffer: ke,
            toBase64: je,
            fromBase64: Ve,
            copyUint8Array: Fe,
            encodeAny: Ge,
            decodeAny: qe,
          })
          ;(t.Decoder = X),
            (t.Encoder = d),
            (t.IncUintOptRleDecoder = Be),
            (t.IncUintOptRleEncoder = $),
            (t.IntDiffDecoder = Ce),
            (t.IntDiffEncoder = F),
            (t.IntDiffOptRleDecoder = Me),
            (t.IntDiffOptRleEncoder = W),
            (t.RleDecoder = Pe),
            (t.RleEncoder = V),
            (t.RleIntDiffDecoder = Te),
            (t.RleIntDiffEncoder = G),
            (t.StringDecoder = Le),
            (t.StringEncoder = J),
            (t.UintOptRleDecoder = Re),
            (t.UintOptRleEncoder = Y),
            (t._readVarStringNative = me),
            (t._readVarStringPolyfill = ye),
            (t._writeVarStringNative = O),
            (t._writeVarStringPolyfill = P),
            (t.buffer = Ye),
            (t.clone = te),
            (t.copyUint8Array = Fe),
            (t.createDecoder = Q),
            (t.createEncoder = l),
            (t.createUint8ArrayFromArrayBuffer = ke),
            (t.createUint8ArrayFromLen = Ue),
            (t.createUint8ArrayViewFromArrayBuffer = xe),
            (t.decodeAny = qe),
            (t.decoding = Ne),
            (t.encodeAny = Ge),
            (t.encoding = K),
            (t.fromBase64 = Ve),
            (t.hasContent = ee),
            (t.length = u),
            (t.peekUint16 = ue),
            (t.peekUint32 = he),
            (t.peekUint8 = le),
            (t.peekVarInt = ge),
            (t.peekVarString = be),
            (t.peekVarUint = ve),
            (t.readAny = Oe),
            (t.readBigInt64 = Ie),
            (t.readBigUint64 = Ae),
            (t.readFloat32 = _e),
            (t.readFloat64 = we),
            (t.readFromDataView = Ee),
            (t.readTailAsUint8Array = re),
            (t.readUint16 = ae),
            (t.readUint32 = ce),
            (t.readUint32BigEndian = de),
            (t.readUint8 = se),
            (t.readUint8Array = ne),
            (t.readVarInt = pe),
            (t.readVarString = Se),
            (t.readVarUint = fe),
            (t.readVarUint8Array = oe),
            (t.set = v),
            (t.setUint16 = S),
            (t.setUint32 = _),
            (t.setUint8 = y),
            (t.skip8 = ie),
            (t.toBase64 = je),
            (t.toUint8Array = h),
            (t.verifyLen = f),
            (t.write = p),
            (t.writeAny = j),
            (t.writeBigInt64 = U),
            (t.writeBigUint64 = x),
            (t.writeBinaryEncoder = T),
            (t.writeFloat32 = L),
            (t.writeFloat64 = N),
            (t.writeOnDataView = M),
            (t.writeUint16 = m),
            (t.writeUint32 = b),
            (t.writeUint32BigEndian = E),
            (t.writeUint8 = g),
            (t.writeUint8Array = R),
            (t.writeVarInt = I),
            (t.writeVarString = C),
            (t.writeVarUint = w),
            (t.writeVarUint8Array = B)
        },
        6477: (e, t) => {
          const n = (e) => (void 0 === e ? null : e)
          var o = Object.freeze({ __proto__: null, undefinedToNull: n })
          ;(t.conditions = o), (t.undefinedToNull = n)
        },
        1840: (e, t, n) => {
          Object.defineProperty(t, '__esModule', { value: !0 })
          var o = n(6797)
          n(409),
            n(7039),
            n(2346),
            n(8720),
            n(2203),
            n(4178),
            n(5537),
            n(6477),
            n(2826),
            n(8346),
            n(9722),
            n(7027),
            (t.Decoder = o.Decoder),
            (t.IncUintOptRleDecoder = o.IncUintOptRleDecoder),
            (t.IntDiffDecoder = o.IntDiffDecoder),
            (t.IntDiffOptRleDecoder = o.IntDiffOptRleDecoder),
            (t.RleDecoder = o.RleDecoder),
            (t.RleIntDiffDecoder = o.RleIntDiffDecoder),
            (t.StringDecoder = o.StringDecoder),
            (t.UintOptRleDecoder = o.UintOptRleDecoder),
            (t._readVarStringNative = o._readVarStringNative),
            (t._readVarStringPolyfill = o._readVarStringPolyfill),
            (t.clone = o.clone),
            (t.createDecoder = o.createDecoder),
            (t.hasContent = o.hasContent),
            (t.peekUint16 = o.peekUint16),
            (t.peekUint32 = o.peekUint32),
            (t.peekUint8 = o.peekUint8),
            (t.peekVarInt = o.peekVarInt),
            (t.peekVarString = o.peekVarString),
            (t.peekVarUint = o.peekVarUint),
            (t.readAny = o.readAny),
            (t.readBigInt64 = o.readBigInt64),
            (t.readBigUint64 = o.readBigUint64),
            (t.readFloat32 = o.readFloat32),
            (t.readFloat64 = o.readFloat64),
            (t.readFromDataView = o.readFromDataView),
            (t.readTailAsUint8Array = o.readTailAsUint8Array),
            (t.readUint16 = o.readUint16),
            (t.readUint32 = o.readUint32),
            (t.readUint32BigEndian = o.readUint32BigEndian),
            (t.readUint8 = o.readUint8),
            (t.readUint8Array = o.readUint8Array),
            (t.readVarInt = o.readVarInt),
            (t.readVarString = o.readVarString),
            (t.readVarUint = o.readVarUint),
            (t.readVarUint8Array = o.readVarUint8Array),
            (t.skip8 = o.skip8)
        },
        4641: (e, t, n) => {
          Object.defineProperty(t, '__esModule', { value: !0 })
          var o = n(6797)
          n(7039),
            n(2346),
            n(409),
            n(8720),
            n(4178),
            n(5537),
            n(6477),
            n(2826),
            n(8346),
            n(9722),
            n(7027),
            n(2203),
            (t.Encoder = o.Encoder),
            (t.IncUintOptRleEncoder = o.IncUintOptRleEncoder),
            (t.IntDiffEncoder = o.IntDiffEncoder),
            (t.IntDiffOptRleEncoder = o.IntDiffOptRleEncoder),
            (t.RleEncoder = o.RleEncoder),
            (t.RleIntDiffEncoder = o.RleIntDiffEncoder),
            (t.StringEncoder = o.StringEncoder),
            (t.UintOptRleEncoder = o.UintOptRleEncoder),
            (t._writeVarStringNative = o._writeVarStringNative),
            (t._writeVarStringPolyfill = o._writeVarStringPolyfill),
            (t.createEncoder = o.createEncoder),
            (t.length = o.length),
            (t.set = o.set),
            (t.setUint16 = o.setUint16),
            (t.setUint32 = o.setUint32),
            (t.setUint8 = o.setUint8),
            (t.toUint8Array = o.toUint8Array),
            (t.verifyLen = o.verifyLen),
            (t.write = o.write),
            (t.writeAny = o.writeAny),
            (t.writeBigInt64 = o.writeBigInt64),
            (t.writeBigUint64 = o.writeBigUint64),
            (t.writeBinaryEncoder = o.writeBinaryEncoder),
            (t.writeFloat32 = o.writeFloat32),
            (t.writeFloat64 = o.writeFloat64),
            (t.writeOnDataView = o.writeOnDataView),
            (t.writeUint16 = o.writeUint16),
            (t.writeUint32 = o.writeUint32),
            (t.writeUint32BigEndian = o.writeUint32BigEndian),
            (t.writeUint8 = o.writeUint8),
            (t.writeUint8Array = o.writeUint8Array),
            (t.writeVarInt = o.writeVarInt),
            (t.writeVarString = o.writeVarString),
            (t.writeVarUint = o.writeVarUint),
            (t.writeVarUint8Array = o.writeVarUint8Array)
        },
        4178: (e, t, n) => {
          var o = n(5537),
            r = n(8720),
            i = n(6477),
            s = n(2826),
            a = n(8346)
          const c =
              'undefined' !== typeof process &&
              process.release &&
              /node|io\.js/.test(process.release.name),
            d = 'undefined' !== typeof window && !c,
            l =
              'undefined' !== typeof navigator && /Mac/.test(navigator.platform)
          let u
          const h = () => {
              if (void 0 === u)
                if (c) {
                  u = o.create()
                  const e = process.argv
                  let t = null
                  for (let n = 0; n < e.length; n++) {
                    const o = e[n]
                    '-' === o[0]
                      ? (null !== t && u.set(t, ''), (t = o))
                      : null !== t && (u.set(t, o), (t = null))
                  }
                  null !== t && u.set(t, '')
                } else
                  'object' === typeof location
                    ? ((u = o.create()),
                      (location.search || '?')
                        .slice(1)
                        .split('&')
                        .forEach((e) => {
                          if (0 !== e.length) {
                            const [t, n] = e.split('=')
                            u.set(`--${r.fromCamelCase(t, '-')}`, n),
                              u.set(`-${r.fromCamelCase(t, '-')}`, n)
                          }
                        }))
                    : (u = o.create())
              return u
            },
            f = (e) => h().has(e),
            p = (e, t) => h().get(e) || t,
            v = (e) =>
              c
                ? i.undefinedToNull(process.env[e.toUpperCase()])
                : i.undefinedToNull(s.varStorage.getItem(e)),
            g = (e) => h().get('--' + e) || v(e),
            y = (e) => f('--' + e) || null !== v(e),
            m = y('production'),
            S = c && a.isOneOf(process.env.FORCE_COLOR, ['true', '1', '2']),
            b =
              !f('no-colors') &&
              (!c || process.stdout.isTTY || S) &&
              (!c ||
                f('color') ||
                S ||
                null !== v('COLORTERM') ||
                (v('TERM') || '').includes('color'))
          var E = Object.freeze({
            __proto__: null,
            isNode: c,
            isBrowser: d,
            isMac: l,
            hasParam: f,
            getParam: p,
            getVariable: v,
            getConf: g,
            hasConf: y,
            production: m,
            supportsColor: b,
          })
          ;(t.environment = E),
            (t.getConf = g),
            (t.getParam = p),
            (t.getVariable = v),
            (t.hasConf = y),
            (t.hasParam = f),
            (t.isBrowser = d),
            (t.isMac = l),
            (t.isNode = c),
            (t.production = m),
            (t.supportsColor = b)
        },
        2203: (e, t) => {
          const n = (e) => new Error(e),
            o = () => {
              throw n('Method unimplemented')
            },
            r = () => {
              throw n('Unexpected case')
            }
          var i = Object.freeze({
            __proto__: null,
            create: n,
            methodUnimplemented: o,
            unexpectedCase: r,
          })
          ;(t.create = n),
            (t.error = i),
            (t.methodUnimplemented = o),
            (t.unexpectedCase = r)
        },
        8346: (e, t, n) => {
          var o = n(9722),
            r = n(7027)
          const i = (e, t, n = 0) => {
              try {
                for (; n < e.length; n++) e[n](...t)
              } finally {
                n < e.length && i(e, t, n + 1)
              }
            },
            s = () => {},
            a = (e) => e(),
            c = (e) => e,
            d = (e, t) => e === t,
            l = (e, t) =>
              e === t ||
              (null != e &&
                null != t &&
                e.constructor === t.constructor &&
                ((e instanceof Array && o.equalFlat(e, t)) ||
                  ('object' === typeof e && r.equalFlat(e, t)))),
            u = (e, t) => {
              if (null == e || null == t) return d(e, t)
              if (e.constructor !== t.constructor) return !1
              if (e === t) return !0
              switch (e.constructor) {
                case ArrayBuffer:
                  ;(e = new Uint8Array(e)), (t = new Uint8Array(t))
                case Uint8Array:
                  if (e.byteLength !== t.byteLength) return !1
                  for (let n = 0; n < e.length; n++)
                    if (e[n] !== t[n]) return !1
                  break
                case Set:
                  if (e.size !== t.size) return !1
                  for (const n of e) if (!t.has(n)) return !1
                  break
                case Map:
                  if (e.size !== t.size) return !1
                  for (const n of e.keys())
                    if (!t.has(n) || !u(e.get(n), t.get(n))) return !1
                  break
                case Object:
                  if (r.length(e) !== r.length(t)) return !1
                  for (const n in e)
                    if (!r.hasProperty(e, n) || !u(e[n], t[n])) return !1
                  break
                case Array:
                  if (e.length !== t.length) return !1
                  for (let n = 0; n < e.length; n++)
                    if (!u(e[n], t[n])) return !1
                  break
                default:
                  return !1
              }
              return !0
            },
            h = (e, t) => t.includes(e)
          var f = Object.freeze({
            __proto__: null,
            callAll: i,
            nop: s,
            apply: a,
            id: c,
            equalityStrict: d,
            equalityFlat: l,
            equalityDeep: u,
            isOneOf: h,
          })
          ;(t._function = f),
            (t.apply = a),
            (t.callAll = i),
            (t.equalityDeep = u),
            (t.equalityFlat = l),
            (t.equalityStrict = d),
            (t.id = c),
            (t.isOneOf = h),
            (t.nop = s)
        },
        5537: (e, t) => {
          const n = () => new Map(),
            o = (e) => {
              const t = n()
              return (
                e.forEach((e, n) => {
                  t.set(n, e)
                }),
                t
              )
            },
            r = (e, t, n) => {
              let o = e.get(t)
              return void 0 === o && e.set(t, (o = n())), o
            },
            i = (e, t) => {
              const n = []
              for (const [o, r] of e) n.push(t(r, o))
              return n
            },
            s = (e, t) => {
              for (const [n, o] of e) if (t(o, n)) return !0
              return !1
            },
            a = (e, t) => {
              for (const [n, o] of e) if (!t(o, n)) return !1
              return !0
            }
          var c = Object.freeze({
            __proto__: null,
            create: n,
            copy: o,
            setIfUndefined: r,
            map: i,
            any: s,
            all: a,
          })
          ;(t.all = a),
            (t.any = s),
            (t.copy = o),
            (t.create = n),
            (t.map = i),
            (t.map$1 = c),
            (t.setIfUndefined = r)
        },
        7039: (e, t) => {
          const n = Math.floor,
            o = Math.ceil,
            r = Math.abs,
            i = Math.imul,
            s = Math.round,
            a = Math.log10,
            c = Math.log2,
            d = Math.log,
            l = Math.sqrt,
            u = (e, t) => e + t,
            h = (e, t) => (e < t ? e : t),
            f = (e, t) => (e > t ? e : t),
            p = Number.isNaN,
            v = Math.pow,
            g = (e) => Math.pow(10, e),
            y = Math.sign,
            m = (e) => (0 !== e ? e < 0 : 1 / e < 0)
          var S = Object.freeze({
            __proto__: null,
            floor: n,
            ceil: o,
            abs: r,
            imul: i,
            round: s,
            log10: a,
            log2: c,
            log: d,
            sqrt: l,
            add: u,
            min: h,
            max: f,
            isNaN: p,
            pow: v,
            exp10: g,
            sign: y,
            isNegativeZero: m,
          })
          ;(t.abs = r),
            (t.add = u),
            (t.ceil = o),
            (t.exp10 = g),
            (t.floor = n),
            (t.imul = i),
            (t.isNaN = p),
            (t.isNegativeZero = m),
            (t.log = d),
            (t.log10 = a),
            (t.log2 = c),
            (t.math = S),
            (t.max = f),
            (t.min = h),
            (t.pow = v),
            (t.round = s),
            (t.sign = y),
            (t.sqrt = l)
        },
        2346: (e, t, n) => {
          var o = n(7039),
            r = n(409)
          const i = Number.MAX_SAFE_INTEGER,
            s = Number.MIN_SAFE_INTEGER,
            a = 1 << 31,
            c = r.BITS31,
            d =
              Number.isInteger ||
              ((e) => 'number' === typeof e && isFinite(e) && o.floor(e) === e),
            l = Number.isNaN,
            u = Number.parseInt
          var h = Object.freeze({
            __proto__: null,
            MAX_SAFE_INTEGER: i,
            MIN_SAFE_INTEGER: s,
            LOWEST_INT32: a,
            HIGHEST_INT32: c,
            isInteger: d,
            isNaN: l,
            parseInt: u,
          })
          ;(t.HIGHEST_INT32 = c),
            (t.LOWEST_INT32 = a),
            (t.MAX_SAFE_INTEGER = i),
            (t.MIN_SAFE_INTEGER = s),
            (t.isInteger = d),
            (t.isNaN = l),
            (t.number = h),
            (t.parseInt = u)
        },
        7027: (e, t) => {
          const n = () => Object.create(null),
            o = Object.assign,
            r = Object.keys,
            i = (e, t) => {
              for (const n in e) t(e[n], n)
            },
            s = (e, t) => {
              const n = []
              for (const o in e) n.push(t(e[o], o))
              return n
            },
            a = (e) => r(e).length,
            c = (e, t) => {
              for (const n in e) if (t(e[n], n)) return !0
              return !1
            },
            d = (e, t) => {
              for (const n in e) if (!t(e[n], n)) return !1
              return !0
            },
            l = (e, t) => Object.prototype.hasOwnProperty.call(e, t),
            u = (e, t) =>
              e === t ||
              (a(e) === a(t) &&
                d(e, (e, n) => (void 0 !== e || l(t, n)) && t[n] === e))
          var h = Object.freeze({
            __proto__: null,
            create: n,
            assign: o,
            keys: r,
            forEach: i,
            map: s,
            length: a,
            some: c,
            every: d,
            hasProperty: l,
            equalFlat: u,
          })
          ;(t.assign = o),
            (t.create = n),
            (t.equalFlat = u),
            (t.every = d),
            (t.forEach = i),
            (t.hasProperty = l),
            (t.keys = r),
            (t.length = a),
            (t.map = s),
            (t.object = h),
            (t.some = c)
        },
        2826: (e, t) => {
          Object.defineProperty(t, '__esModule', { value: !0 })
          let n = new (class {
              constructor() {
                this.map = new Map()
              }
              setItem(e, t) {
                this.map.set(e, t)
              }
              getItem(e) {
                return this.map.get(e)
              }
            })(),
            o = !0
          try {
            'undefined' !== typeof localStorage &&
              ((n = localStorage), (o = !1))
          } catch (i) {}
          const r = n
          ;(t.onChange = (e) => o || addEventListener('storage', e)),
            (t.varStorage = r)
        },
        8720: (e, t) => {
          const n = String.fromCharCode,
            o = String.fromCodePoint,
            r = /^\s*/g,
            i = (e) => e.replace(r, ''),
            s = /([A-Z])/g,
            a = (e, t) =>
              i(e.replace(s, (e) => `${t}${((e) => e.toLowerCase())(e)}`)),
            c = (e) => unescape(encodeURIComponent(e)).length,
            d = (e) => {
              const t = unescape(encodeURIComponent(e)),
                n = t.length,
                o = new Uint8Array(n)
              for (let r = 0; r < n; r++) o[r] = t.codePointAt(r)
              return o
            },
            l = 'undefined' !== typeof TextEncoder ? new TextEncoder() : null,
            u = (e) => l.encode(e),
            h = l ? u : d,
            f = (e) => {
              let t = e.length,
                n = '',
                o = 0
              for (; t > 0; ) {
                const r = t < 1e4 ? t : 1e4,
                  i = e.subarray(o, o + r)
                ;(o += r), (n += String.fromCodePoint.apply(null, i)), (t -= r)
              }
              return decodeURIComponent(escape(n))
            }
          ;(t.utf8TextDecoder =
            'undefined' === typeof TextDecoder
              ? null
              : new TextDecoder('utf-8', { fatal: !0, ignoreBOM: !0 })),
            t.utf8TextDecoder &&
              1 === t.utf8TextDecoder.decode(new Uint8Array()).length &&
              (t.utf8TextDecoder = null)
          const p = (e) => t.utf8TextDecoder.decode(e),
            v = t.utf8TextDecoder ? p : f,
            g = (e, t, n, o = '') => e.slice(0, t) + o + e.slice(t + n)
          var y = Object.freeze({
            __proto__: null,
            fromCharCode: n,
            fromCodePoint: o,
            trimLeft: i,
            fromCamelCase: a,
            utf8ByteLength: c,
            _encodeUtf8Polyfill: d,
            utf8TextEncoder: l,
            _encodeUtf8Native: u,
            encodeUtf8: h,
            _decodeUtf8Polyfill: f,
            get utf8TextDecoder() {
              return t.utf8TextDecoder
            },
            _decodeUtf8Native: p,
            decodeUtf8: v,
            splice: g,
          })
          ;(t._decodeUtf8Native = p),
            (t._decodeUtf8Polyfill = f),
            (t._encodeUtf8Native = u),
            (t._encodeUtf8Polyfill = d),
            (t.decodeUtf8 = v),
            (t.encodeUtf8 = h),
            (t.fromCamelCase = a),
            (t.fromCharCode = n),
            (t.fromCodePoint = o),
            (t.splice = g),
            (t.string = y),
            (t.trimLeft = i),
            (t.utf8ByteLength = c),
            (t.utf8TextEncoder = l)
        },
        297: (e, t, n) => {
          n.r(t),
            n.d(t, {
              add: () => p,
              addAutoKey: () => v,
              count: () => l,
              createIDBKeyRangeBound: () => D,
              createIDBKeyRangeLowerBound: () => P,
              createIDBKeyRangeUpperBound: () => O,
              createStores: () => c,
              del: () => h,
              deleteDB: () => a,
              get: () => u,
              getAll: () => g,
              getAllKeys: () => y,
              getAllKeysValues: () => E,
              getFirstKey: () => b,
              getLastKey: () => S,
              getStore: () => A,
              iterate: () => w,
              iterateKeys: () => I,
              openDB: () => s,
              put: () => f,
              queryFirst: () => m,
              rtop: () => i,
              transact: () => d,
            })
          const o = (e) => new Promise(e),
            r = (e) => new Error(e),
            i = (e) =>
              o((t, n) => {
                ;(e.onerror = (e) => n(new Error(e.target.error))),
                  (e.onblocked = () => location.reload()),
                  (e.onsuccess = (e) => t(e.target.result))
              }),
            s = (e, t) =>
              o((n, o) => {
                const i = indexedDB.open(e)
                ;(i.onupgradeneeded = (e) => t(e.target.result)),
                  (i.onerror = (e) => o(r(e.target.error))),
                  (i.onblocked = () => location.reload()),
                  (i.onsuccess = (e) => {
                    const t = e.target.result
                    ;(t.onversionchange = () => {
                      t.close()
                    }),
                      'undefined' !== typeof addEventListener &&
                        addEventListener('unload', () => t.close()),
                      n(t)
                  })
              }),
            a = (e) => i(indexedDB.deleteDatabase(e)),
            c = (e, t) => t.forEach((t) => e.createObjectStore.apply(e, t)),
            d = (e, t, n = 'readwrite') => {
              const o = e.transaction(t, n)
              return t.map((e) => A(o, e))
            },
            l = (e, t) => i(e.count(t)),
            u = (e, t) => i(e.get(t)),
            h = (e, t) => i(e.delete(t)),
            f = (e, t, n) => i(e.put(t, n)),
            p = (e, t, n) => i(e.add(t, n)),
            v = (e, t) => i(e.add(t)),
            g = (e, t, n) => i(e.getAll(t, n)),
            y = (e, t, n) => i(e.getAllKeys(t, n)),
            m = (e, t, n) => {
              let o = null
              return I(e, t, (e) => ((o = e), !1), n).then(() => o)
            },
            S = (e, t = null) => m(e, t, 'prev'),
            b = (e, t = null) => m(e, t, 'next'),
            E = (e, t, n) => {
              return ((o = [y(e, t, n), g(e, t, n)]), Promise.all(o)).then(
                ([e, t]) => e.map((e, n) => ({ k: e, v: t[n] }))
              )
              var o
            },
            _ = (e, t) =>
              o((n, o) => {
                ;(e.onerror = o),
                  (e.onsuccess = async (e) => {
                    const o = e.target.result
                    if (null === o || !1 === (await t(o))) return n()
                    o.continue()
                  })
              }),
            w = (e, t, n, o = 'next') =>
              _(e.openCursor(t, o), (e) => n(e.value, e.key)),
            I = (e, t, n, o = 'next') =>
              _(e.openKeyCursor(t, o), (e) => n(e.key)),
            A = (e, t) => e.objectStore(t),
            D = (e, t, n, o) => IDBKeyRange.bound(e, t, n, o),
            O = (e, t) => IDBKeyRange.upperBound(e, t),
            P = (e, t) => IDBKeyRange.lowerBound(e, t)
        },
        5750: (e, t, n) => {
          n.r(t), n.d(t, { Observable: () => s })
          const o = () => new Map(),
            r = () => new Set(),
            i = Array.from
          Array.isArray
          class s {
            constructor() {
              this._observers = o()
            }
            on(e, t) {
              ;((e, t, n) => {
                let o = e.get(t)
                return void 0 === o && e.set(t, (o = n())), o
              })(this._observers, e, r).add(t)
            }
            once(e, t) {
              const n = (...o) => {
                this.off(e, n), t(...o)
              }
              this.on(e, n)
            }
            off(e, t) {
              const n = this._observers.get(e)
              void 0 !== n &&
                (n.delete(t), 0 === n.size && this._observers.delete(e))
            }
            emit(e, t) {
              return i((this._observers.get(e) || o()).values()).forEach((e) =>
                e(...t)
              )
            }
            destroy() {
              this._observers = o()
            }
          }
        },
      },
      i = {}
    function s(e) {
      var t = i[e]
      if (void 0 !== t) return t.exports
      var n = (i[e] = { exports: {} })
      return r[e].call(n.exports, n, n.exports, s), n.exports
    }
    return (
      (s.d = (e, t) => {
        for (var n in t)
          s.o(t, n) &&
            !s.o(e, n) &&
            Object.defineProperty(e, n, { enumerable: !0, get: t[n] })
      }),
      (s.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
      (s.r = (e) => {
        'undefined' !== typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(e, Symbol.toStringTag, { value: 'Module' }),
          Object.defineProperty(e, '__esModule', { value: !0 })
      }),
      s(6814)
    )
  })()
)
